<template>
  <!-- 首页 -->
  <div class="content" ref="content">
    <!-- 背景轮播 -->
    <vide ref="video" @fromData="sumbit" />

    <!-- 内容区域 -->
    <div class="contenta" :style="contenta ? 'padding-top:150px' : ''" v-if="goods.arrlist.length > 0">
      <!-- 功能按钮 -->
      <div class="menus" :style="contenta
        ? 'width:100%;padding:20px 20%;backgroundColor:rgba(3, 10, 19, 0.5)'
        : ''
        ">
        <div v-show="!collipsePanel" class="menus-p">
          <!-- <el-button v-if="userInfo.rules && userInfo.rules.includes('4')" @click="generatorImage" type="success" plain size="small" class="btn btn1">
            <span class="mt3">原图下载</span>
          </el-button> -->
          <el-popover trigger="hover" placement="bottom" size="small" plain width="340" class="btn btn1">
            <el-button slot="reference" v-if="userInfo.rules && userInfo.rules.includes('4')" @click="generatorImage" type="success" size="small" plain style="width: 100%" class="btn-1">
              <span class="mt3">原图下载</span>
            </el-button>
            <div style="padding: 0px 20px">
              <img :src="drawSrc" style="max-width:300px;" />
            </div>
          </el-popover>
          <el-popover trigger="hover" placement="bottom" size="small" plain width="235" class="btn btn1">
            <el-button slot="reference" @click="addGoods" type="success" plain size="small" style="width: 100%" class="btn-1">
              <span class="mt3">添加商品</span>
            </el-button>
            <div style="padding: 0px 20px">
              <el-button type="success" size="small" style="width: 100%" @click="showGoodsName = !showGoodsName">
                {{ showGoodsName ? "隐藏" : "显示" }}商品行名称
              </el-button>
            </div>
          </el-popover>
          <el-button @click="suit(0)" type="success" plain size="small" class="btn btn1">
            <span class="mt3">套装归类</span>
          </el-button>
          <el-button v-popover:popover3 @click="showFilter" type="success" plain size="small" class="btn btn1">
            <span class="mt3">图片滤镜</span>
          </el-button>
          <el-button v-popover:popover1 @click="showTitlte" type="success" plain size="small" class="btn btn1">
            <span class="mt3">标题文字</span>
          </el-button>
          <el-button @click="showPrice" type="success" plain size="small" class="btn btn1">
            <span class="mt3">显示隐藏{{ liveTypes ? "" : "价格" }}</span>
          </el-button>
          <el-button @click="showGrade" type="success" plain size="small" class="btn btn1">
            <span class="mt3">物品标签</span>
          </el-button>
          <el-select class="select btn btn1" v-model="select.value" placeholder="请选择" @change="selectChange">
            <el-option v-for="item in select.options" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <el-button v-popover:popover2 @click="showBjColor" type="success" size="small" plain class="btn btn1">
            <span class="mt3">背景颜色</span>
          </el-button>
          <el-button @click="suit(1)" type="success" size="small" plain class="btn btn1">
            <span class="mt3">自动排版</span>
          </el-button>
          <el-button @click="finalizeDialogShow = true" type="success" size="small" plain class="btn btn1">
            <span class="mt3">微信分享库存</span>
          </el-button>
          <el-button @click="searchVac" type="success" size="small" plain class="btn btn1">
            <span class="mt3">查询vac封禁</span>
          </el-button>
        </div>
        <div v-if="facility == 'pc'" class="collipse-btn" @click="clickCollipse">
          <i class="el-icon-arrow-up" :style="{
            transform: collipsePanel ? 'rotate(180deg)' : 'rotate(0deg)',
          }" />
        </div>
      </div>
      <el-popover ref="popover3" popper-class="my-popover home-title-setting" trigger="manual" placement="bottom" size="small" plain :width="facility == 'pc' ? 400 : 300" v-model="filtervisible">
        <div style="padding: 0px 20px">
          <div class="flex-a">
            <span class="flex-a-title">灰度({{ filterStyle.grey }})：</span>
            <div class="flex-a-content">
              <el-slider v-model="filterStyle.grey" :step="0.1" :max="1" :show-tooltip="false"></el-slider>
            </div>
          </div>
          <div class="flex-a">
            <span class="flex-a-title">
              高斯模糊({{ filterStyle.gass }})：
            </span>
            <div class="flex-a-content">
              <el-slider v-model="filterStyle.gass" :step="1" :max="50" :show-tooltip="false"></el-slider>
            </div>
          </div>
          <div class="flex-a">
            <span class="flex-a-title">
              深褐色({{ filterStyle.sepia }})：
            </span>
            <div class="flex-a-content">
              <el-slider v-model="filterStyle.sepia" :step="0.1" :max="1" :show-tooltip="false"></el-slider>
            </div>
          </div>
          <div class="flex-a">
            <span class="flex-a-title">
              饱和度({{ filterStyle.saturation }})：
            </span>
            <div class="flex-a-content">
              <el-slider v-model="filterStyle.saturation" :step="0.1" :max="2" :show-tooltip="false"></el-slider>
            </div>
          </div>
          <div class="flex-a">
            <span class="flex-a-title">
              透明度({{ filterStyle.opacity }})：
            </span>
            <div class="flex-a-content">
              <el-slider v-model="filterStyle.opacity" :step="0.1" :max="1" :show-tooltip="false"></el-slider>
            </div>
          </div>
          <div class="flex-a">
            <span class="flex-a-title">
              亮暗度({{ filterStyle.brightness }})：
            </span>
            <div class="flex-a-content">
              <el-slider v-model="filterStyle.brightness" :step="0.1" :max="5" :show-tooltip="false"></el-slider>
            </div>
          </div>
          <div class="flex-a">
            <span class="flex-a-title">
              对比度({{ filterStyle.contrast }})：
            </span>
            <div class="flex-a-content">
              <el-slider v-model="filterStyle.contrast" :step="0.1" :max="1" :show-tooltip="false"></el-slider>
            </div>
          </div>
          <div class="flex-a">
            <span class="flex-a-title">
              色相转换({{ filterStyle.hueRotate }})：
            </span>
            <div class="flex-a-content">
              <el-slider v-model="filterStyle.hueRotate" :step="1" :min="-360" :max="360" :show-tooltip="false"></el-slider>
            </div>
          </div>
          <div class="flex-a">
            <span class="flex-a-title">
              反转({{ filterStyle.invert }})：
            </span>
            <div class="flex-a-content">
              <el-slider v-model="filterStyle.invert" :step="0.1" :max="2" :show-tooltip="false"></el-slider>
            </div>
          </div>
          <div style="text-align: center; margin-top: 30px">
            <el-button type="warning" plain size="small" @click="resetFilterStyle">
              重置
            </el-button>
            <el-button plain size="small" @click="filtervisible = false">
              关闭
            </el-button>
          </div>
        </div>
      </el-popover>
      <el-popover ref="popover1" popper-class="my-popover home-title-setting" trigger="manual" placement="bottom" size="small" plain width="295" v-model="visible">
        <div style="padding: 0px 20px">
          <div class="flex-a">
            <span>修改标题：</span>
            <el-input type="textarea" :rows="2" placeholder="请输入标题" v-model="goods.newTitle.text"></el-input>
          </div>
          <div class="flex-a" style="margin: 5px 0">
            <span>修改{{ liveTypes ? "" : "价格" }}：</span>
            <input type="text" class="title-input" placeholder="请输入内容" maxlength="10" @keyup="
              goods.newTitle.number = goods.newTitle.number.replace(
                /[, ]/g,
                ''
              )
              " v-model="goods.newTitle.number" />
          </div>
          <div class="flex-a" style="margin: 10px 0">
            <span>字体大小：</span>
            <input style="color: #333 !important" v-model="goods.newTitle.fontSzie" placeholder="请输入文字大小" />
          </div>
          <div class="flex-a">
            <span>字体颜色：</span>
            <ColorPicker v-model="goods.newTitle.fontColor" />
          </div>
          <div class="flex-a">
            <span>字体样式：</span>
            <el-select ref="FontFamilySelect" v-model="goods.newTitle.fontFamily" placeholder="请选择" size="mini" class="font-family-select">
              <el-option v-for="item in fontFamilyOptions" :key="item.value" :label="item.label" :value="item.value">
                <span :style="{ 'font-family': item.value }">
                  {{ item.label }}
                </span>
              </el-option>
            </el-select>
          </div>
          <div style="text-align: center; margin-top: 30px">
            <el-button type="warning" plain size="small" @click="resetStyle">
              重置
            </el-button>
            <el-button plain size="small" @click="cancelStyle">
              取消
            </el-button>
            <el-button type="success" size="small" @click="sumbitStyle">
              确定
            </el-button>
          </div>
        </div>
      </el-popover>
      <el-popover ref="popover2" trigger="manual" placement="bottom" size="small" plain width="295" v-model="bjvisible">
        <div style="padding: 0px 20px">
          <div class="flex-a">
            <span>背景颜色</span>
            <el-input v-model="goods.goodsBjColor" placeholder="请选择颜色" type="color"></el-input>
          </div>
          <el-button type="success" size="small" @click="bjvisible = false">
            关闭
          </el-button>
        </div>
      </el-popover>
      <el-popover ref="popover6" trigger="manual" placement="bottom" size="small" plain width="295"></el-popover>
      <!-- 商品内容 -->
      <div class="goods" id="goods">
        <!-- 商品 -->
        <div class="goods_content" ref="canvasImg" :style="{ backgroundColor: `${goods.goodsBjColor}` }">
          <div class="temp_content temp_content_top">
            <!-- 左页签 -->
            <div v-if="goods.rank > 0" class="top_left_xie top_xie">
              <span>{{ goods.rank }}级</span>
            </div>
            <!-- 右页签 -->
            <!-- <div v-if="goods.rank > 79" class="top_right_xie top_xie">
              <span>可排位</span>
            </div> -->
            <!-- <div class="top_right_xie top_xie">
              <span>{{ goods.is_captain ? "豪华版" : "免费版" }}</span>
            </div> -->
            <div :class="{ active: goods.is_captain == 1 }" class="top_right_xie top_xie">
              <span>{{ goods.is_captain == 1 ? "PLUS+已激活" : "免费版" }}</span>
            </div>

            <!-- 标题 -->
            <!--<div-->

            <!--class="title"-->
            <!--:style="{-->
            <!--fontSize: goods.oldTitle.fontSzie + 'px',-->
            <!--color: goods.oldTitle.fontColor,-->
            <!--}"-->
            <!--&gt;-->
            <!--{{ goods.subtitle }}{{ goods.subprices }}-->
            <!---->
            <!--</div>-->
            <div class="title" :style="{
              fontSize: goods.oldTitle.fontSzie + 'px',
            }">
              <!-- <span
                :style="{
                  'font-family': goods.oldTitle.fontFamily,
                }"
              >
                {{ liveTypes ? "" : goods.oldTitle.text }}
                <template v-if="isPrice">
                  {{ goods.prices }}
                </template>
              </span> -->
              <span :style="{
                'background-image': goods.oldTitle.fontColor,
                '-webkit-background-clip': 'text',
                'text-fill-color': 'transparent',
                'font-family': goods.oldTitle.fontFamily,
              }">
                {{ liveTypes ? "" : goods.oldTitle.text }}
                <template v-if="isPrice">
                  {{ goods.prices }}
                </template>
              </span>
              <!-- <div :style="{
                background: goods.oldTitle.fontColor,
              }" class="title-bg"></div> -->
            </div>
            <div v-if="!!goods.subprices" class="subtitle">
              {{ goods.subprices }}
            </div>
            <!-- 通行证图片 -->
            <div class="listTopBody">
              <div v-for="(item, index) in goods.listTop" :key="index" class="topImg w50" :style="filterStyleComputed">
                <img class="imga" ref="imga" :src="item.pic_image" crossorigin="anonymous" @load="successLoadImg" alt="" />
              </div>
            </div>
          </div>
          <div class="temp_content">
            <!-- 套装归类 -->
            <div v-for="(item1, index) in goods.suitData" :key="index + '-suit'" class="flex-box suit-box" style="min-height: 85px; border-bottom: 2px solid #999">
              <div class="handle-btn" id="handle-btn" :style="{ display: suitDownloading ? 'none' : 'flex' }">
                <i class="suit-top" @click="moveTop(index)"></i>
                <i class="suit-delete" @click="suitDelete(index)"></i>
                <i class="suit-bottom" @click="moveBottom(index)"></i>
              </div>
              <div class="suit-r-p">
                <div v-if="showGoodsName && !suitDownloading" class="suit-r-title">
                  <el-input v-model="goods.suitData[index].name"></el-input>
                </div>
                <div v-else-if="showGoodsName && suitDownloading" class="suit-r-title">{{ goods.suitData[index].name }}</div>
                <draggable v-model="goods.suitData[index].list" group="site" :distance="1" :fallbackTolerance="facility == 'pc' ? 0 : 1" animation="100" dragClass="dragClass" ghostClass="ghostClass" chosenClass="chosenClass" @start="onStart" @end="onEnd" class="goods_body goods_bodya goods_bodyb">
                  <transition-group>
                    <div class="goods_item" style="justify-content: center !important" :style="`${item1.select.goodSize}${filterStyleComputed}`" v-for="(item, v) in goods.suitData[index].list" :key="`suit-${item.id}${item.classid}`" :class="[
                      {
                        goods_item_active:
                          `${item.id}${item.classid}` ===
                          `${goodsId}${classid}`,
                      },
                      rarity(item.rarity),
                    ]" @click="getDetail(0, item, index, '套装', item1, v)">
                      <!-- <template v-if="index == 0 && item1.list.length >= 6">
                        <i v-if="index == 0 && v <= 5" :class="`active${myDotBgColor(v)}`" class="my-dot"></i>
                      </template> -->
                      <template v-if="index == 0 && v == 0">
                        <i :class="{ active: item.rarity == 0, active1: item.number > 1, active2: item.price > 0 }" class="my-dot">{{ myDotNumber() }}</i>
                      </template>
                      <div>
                        <div class="item_top_right_xie" :class="`item_top_right_xie${index}`" v-show="isGrade && item.grade">
                          <span class="item_top_right_xie_span" :class="`item_top_right_xie_span${index}`" v-if="item.is_up == 0">
                            {{ item.grade }}
                          </span>
                          <span class="item_top_right_xie_span" :class="`item_top_right_xie_span${index}`" v-else>
                            {{ filterGrade(item.grade) }}
                          </span>
                        </div>
                        <img style="width: 85%" class="imga" ref="imga" :src="`${item.pic_image?.includes('https') ? '' : config.imageUrl}${item.pic_image}`" crossOrigin="anonymous" />
                      </div>
                      <span :style="`${getSpanColor(item)}; ${item1.select.priceFontSize}`" class="n-flex n-row-center">{{ item.price <= 0 ? "" : "￥" + item.price }}</span>
                          <strong class="nums" v-if="item.number > 1">X{{ item.number }}</strong>
                          <div v-if="item1.isCheck" @click.stop="" class="check">
                            <el-checkbox v-model="item.checked"></el-checkbox>
                          </div>
                    </div>
                  </transition-group>
                </draggable>
              </div>
              <div class="handle-btn" id="handle-btn1" :style="{ display: suitDownloading ? 'none' : 'flex', padding: '4px 0' }">
                <div @click="shopTopping(item1, index)" class="icon">
                  <span class="iconfont icon-topping"></span>
                </div>
                <div v-if="facility == 'pc'" @click="shopCheck(item1, index)" class="icon">
                  <span class="iconfont icon-check"></span>
                </div>
                <div v-else class=""></div>
                <!-- <div @click="shopSetting(item1, index)" class="icon">
                  <span class="iconfont icon-setting"></span>
                </div> -->
                <el-dropdown v-if="facility == 'pc'" @command="handleCommand($event, item1, index)">
                  <div class="icon">
                    <span class="iconfont icon-setting color000"></span>
                  </div>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="7">一行显示7个</el-dropdown-item>
                    <el-dropdown-item command="10">一行显示10个</el-dropdown-item>
                    <el-dropdown-item command="12">一行显示12个</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <div v-else class=""></div>
              </div>
            </div>
          </div>

          <!-- 置顶 -->
          <div @click="toTop" class="to_top top-topping">
            <i class="iconfont icon-topping"></i>
            <p>顶部</p>
          </div>

          <div class="progress-box" v-if="progress.percentage < 100 && facility == 'pc'">
            <el-progress :text-inside="true" :stroke-width="20" :format="progressFormat" text-color="#333" :percentage="progress.percentage" status="success"></el-progress>
          </div>
          <div v-for="(arrItem, arrIndex) in  goods.arrlist " :key="arrIndex" class="temp_content">
            <!-- 中间商品 -->
            <draggable v-model="goods.arrlist[arrIndex]" group="site" :distance="1" :fallbackTolerance="facility == 'pc' ? 0 : 1" animation="100" dragClass="dragClass" ghostClass="ghostClass" chosenClass="chosenClass" @start="onStart" @end="onEnd" class="goods_body">
              <transition-group>
                <div className="middle_item" class="goods_item" :style="`${select.goodSize}${filterStyleComputed}`" v-for="(item, index) in  goods.arrlist[arrIndex] " :key="`${item.id}${item.classid}`" :class="[
                  {
                    goods_item_active:
                      `${item.id}${item.classid}` === `${goodsId}${classid}`,
                  },
                  rarity(item.rarity),
                ]" @click="getDetail(0, item, index, arrIndex)">
                  <template v-if="arrIndex == 0 && index == 0 && (goods.suitData.length ? !goods.suitData[0]?.list?.length : true)">
                    <i :class="{ active: item.rarity == 0, active1: item.number > 1, active2: item.price > 0 }" class="my-dot">{{ myDotNumber() }}</i>
                  </template>
                  <div>
                    <div class="item_top_right_xie good_item_top_right_xie" v-show="isGrade && item.grade">
                      <span class="item_top_right_xie_span good_item_top_right_xie_span" v-if="item.is_up == 0">
                        {{ item.grade }}
                      </span>
                      <span class="item_top_right_xie_span good_item_top_right_xie_span" v-else>
                        {{ filterGrade(item.grade) }}
                      </span>
                    </div>
                    <img class="imga" ref="imga" style="width: 85%" :src="`${item.pic_image?.includes('https') ? '' : config.imageUrl}${item.pic_image}`" crossOrigin="anonymous" @load="successLoadImg" />
                  </div>
                  <span :style="`${getSpanColor(item)}; ${select.priceFontSize}`">
                    {{ item.price <= 0 ? "" : "￥" + item.price }} </span>
                      <strong class="nums" v-if="item.number > 1">X{{ item.number }}</strong>
                </div>
              </transition-group>
            </draggable>
          </div>
          <div class="temp_content temp_content_bottom">
            <!-- 内容底部小图 -->
            <div>
              <draggable v-model="goods.bottomArr" group="site" :distance="1" :fallbackTolerance="facility == 'pc' ? 0 : 1" animation="100" dragClass="dragClass" ghostClass="ghostClass" chosenClass="chosenClass" @start="onStart" @end="onEnd" class="goods_body">
                <transition-group>
                  <div class="zc_img_body zc_img_bodya n-flex" :style="`${'margin: 0 0 3px'}; ${select.bottomSize}; ${filterStyleComputed};`" v-for=" item  in  goods.bottomArr " :key="item.id" :class="rarity(item.rarity)">
                    <img class="zc_img zc_img_a" ref="imga" :src="`${item.pic_image?.includes('https') ? '' : config.imageUrl}${item.pic_image}`" crossOrigin="anonymous" @load="successLoadImg" alt="" />

                  </div>
                </transition-group>
              </draggable>
            </div>
          </div>
        </div>
        <div class="price_left" v-show="liveTypes">{{ goods.prices }}</div>
        <!-- 详情区 -->
        <div class="goods_pc_left goods_pc_box" v-show="goodsId">
          <i class="el-icon-close custom-close" @click="goodsId = null" />
          <!-- 头部图片 -->
          <div class="img-box" :class="rarity(goods.detail.rarity)">
            <div class="top_right_xie" v-show="isGrade && goods.detail.grade">
              <span>{{ goods.detail.grade }}</span>
            </div>
            <img v-if="goods.detail.pic_image" :src="`${goods.detail?.pic_image?.includes('https') ? '' : config.imageUrl}${goods.detail.pic_image}`" alt="" />
          </div>
          <p class="detail_name" v-if="goods.detail.name_c">
            {{ goods.detail.name_c }}
          </p>
          <p class="detail_name">{{ goods.detail.name }}</p>
          <!-- 信息 -->
          <el-form ref="form" :model="forma" label-width="60px">
            <el-form-item label="价格：">
              <span style="color: #fff">
                ￥ {{ goods.detail.price ? goods.detail.price : "0.00" }}
              </span>
            </el-form-item>
            <el-form-item label="标签：" v-if="goods.detail.is_up == 0">
              <el-input @input="getUpData" @clear="clearInput(goods.detail.grade, 1)" maxlength="4" size="mini" clearable v-model="goods.detail.grade" @keyup="
                goods.detail.grade = goods.detail.grade.replace(/[, ]/g, '')
                "></el-input>
            </el-form-item>
            <el-form-item label="等级：" v-else>
              <el-select v-model="goods.detail.grade" placeholder="请选择等级" @change="getArmsPrices">
                <el-option v-for=" item  in 
  goods.detail.is_up == 1 &&
    goods.armsGradeOptions.length > 0
    ? goods.armsGradeOptions
    : goods.gradeOptions
" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="背景：">
              <el-select v-model="rankValue" placeholder="请选择背景" @change="rankValueChange">
                <el-option v-for=" item  in  rankOptins " :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="描述：">
              <span style="color: #fff" v-if="goods.detail.marketable == '1'">
                Steam市场可出售
              </span>
              <span style="color: #fff" v-else>Steam市场不可出售</span>
            </el-form-item>
          </el-form>
          <div class="btns">
            <el-button style="margin-right: 20px !important" type="success" class="btn-d" @click="remove" size="mini">
              删除
            </el-button>
            <el-button v-show="goods.detailTopShow" style="margin-left: 20px !important" type="success" class="btn-s" size="mini" @click="Topping">
              置顶
            </el-button>
          </div>
        </div>
        <!-- 估价 -->
        <div v-if="facility == 'pc' && userInfo.rules && userInfo.rules.includes('3')
          " class="assess-pc-left">
          <assessPanel :collections_id="collections_id" :showPrice="isPrice" @assessSuccess="assessSuccess" @changeShowPanel="changeShowPanel"></assessPanel>
        </div>
        <!-- 估价结果 -->
        <assessDialog v-if="userInfo.rules && userInfo.rules.includes('3')" ref="assessDialog" :showPrice="isPrice" />
        <!-- 估价记录 -->
        <div v-if="facility == 'pc' &&
          this.form.steam_id != '' &&
          userInfo.rules &&
          userInfo.rules.includes('3')
          " class="assess-pc-record">
          <assessRecord ref="assessRecord" :steamId="this.form.steam_id" />
        </div>

        <!-- 暂存区 -->
        <div class="goods_pc_right">
          <img class="staging_top_img" src="../assets/img/stagingBg.png" alt="" />
          <div class="staging_top_btn">
            <div @click="(show3 = !show3), (show4 = false), (show5 = false)" class="top_btns">
              暂存区
              <span class="iconfont icon-arrow-top" v-if="show3"></span>
              <span class="iconfont icon-arrow-bottom" v-else></span>
            </div>
            <div @click="(show4 = !show4), (show3 = false), (show5 = false)" class="top_btns">
              素材区
              <span class="iconfont icon-arrow-top" v-if="show4"></span>
              <span class="iconfont icon-arrow-bottom" v-else></span>
            </div>
            <div @click="(show5 = !show5), (show3 = false), (show4 = false)" class="top_btns">
              主播区
              <span class="iconfont icon-arrow-top" v-if="show5"></span>
              <span class="iconfont icon-arrow-bottom" v-else></span>
            </div>
          </div>
          <transition name="fade-slide" mode="out-in">
            <div v-if="show3" :key="'show3'">
              <div class="transition-box goods_pc_box">
                <div @click="transitionMove" class="delete-m">清空</div>
                <draggable v-model="goods.staging" :distance="1" :fallbackTolerance="facility == 'pc' ? 0 : 1" group="site" animation="100" dragClass="dragClass" ghostClass="ghostClass" chosenClass="chosenClass" @start="onStart" @end="onEnd" class="goods_body">
                  <transition-group>
                    <div class="zc_img_body" v-for=" item  in  goods.staging " :key="item.id" :class="rarity(item.rarity)">
                      <!-- <img class="zc_img" :src="item.pic_image" alt="" /> -->
                      <img class="zc_img" :src="`${item.pic_image?.includes('https') ? '' : config.imageUrl}${item.pic_image}`" alt="" />
                    </div>
                  </transition-group>
                </draggable>
              </div>
            </div>
            <div v-if="show4" :key="'show4'">
              <div class="transition-box goods_pc_box">
                <draggable v-model="goods.library" :distance="1" :fallbackTolerance="facility == 'pc' ? 0 : 1" group="site" animation="100" dragClass="dragClass" ghostClass="ghostClass" chosenClass="chosenClass" @start="onStart" @end="onEnd" class="goods_body">
                  <transition-group>
                    <div class="zc_img_body" v-for=" item  in  goods.library " :key="item.id" :class="rarity(item.rarity)">
                      <!-- <img class="zc_img" :src="item.pic_image" alt="" /> -->
                      <img class="zc_img" :src="`${item.pic_image?.includes('https') ? '' : config.imageUrl}${item.pic_image}`" alt="" />
                    </div>
                  </transition-group>
                </draggable>
              </div>
            </div>
            <div v-if="show5" :key="'show5'">
              <div class="transition-box goods_pc_box">
                <div class="goods_body">
                  <div class="zc_img_body_half" v-for=" item  in  originSteamerList " :key="item.id" @click="steamerClick(item)">
                    <div class="zc_img_half-p">
                      <img class="zc_img_half" :src="item.pic_image" alt="" />
                    </div>
                    <div class="zc_img_half-tag" :title="item.tag">{{ item.tag }}</div>
                    <div class="zc_img_half-name" :title="item.title">{{ item.title }}</div>
                  </div>
                </div>
              </div>
            </div>
          </transition>
        </div>
        <!-- 主播详情 -->
        <div class="goods_pc_box goods_pc_anchor_right beauty-scroll" v-show="showSteamerDetail" style="background:#525252;overflow-y:auto;">
          <i class="el-icon-close custom-close" @click="showSteamerDetail = false" />
          <!-- <div class="anchor-detail-t">
            <img :src="steamerDetail.pic_image" class="anchor-detail-t-img" />
          </div> -->
          <div v-if="steamerDetail.code_image" class="anchor-detail-b">
            <img :src="steamerDetail.code_image" class="anchor-detail-b-img" />
          </div>
          <!-- 信息 -->
          <el-form ref="form" :model="steamerDetail" label-width="60px">
            <el-form-item v-if="steamerDetail.tag" label="职位：">
              <span style="color: #fff">
                {{ steamerDetail.tag }}
              </span>
            </el-form-item>
            <el-form-item v-if="steamerDetail.info" label="简介：">
              <span style="color: #fff">
                {{ steamerDetail.info }}
              </span>
            </el-form-item>
            <el-form-item v-if="steamerDetail.wechat" label="微信：">
              <span class="wechatClipboard" style="color: #fff">
                {{ steamerDetail.wechat }}
              </span>
              <el-button class="wechatClipboardBtn" @click="wechatCopy">复制</el-button>
            </el-form-item>
            <el-form-item v-if="steamerDetail.qq" label="QQ：">
              <span class="qqClipboard" style="color: #fff">
                {{ steamerDetail.qq }}
              </span>
              <el-button class="qqClipboardBtn" @click="qqCopy">复制</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>

    <!-- 移动端详情区 -->
    <el-dialog :visible.sync="dialogVisible" width="85%" :before-close="handleClose">
      <div class="goods_phone_left">
        <!-- 头部图片 -->
        <div class="img-box" :class="rarity(goods.detail.rarity)">
          <div class="top_right_xie" v-show="isGrade && goods.detail.grade">
            <span>{{ goods.detail.grade }}</span>
          </div>
          <!-- <img :src="goods.detail.pic_image" alt="" /> -->
          <img v-if="goods.detail.pic_image" :src="`${goods.detail?.pic_image?.includes('https') ? '' : config.imageUrl}${goods.detail.pic_image}`" alt="" />
        </div>
        <p class="detail_name" v-if="goods.detail.name_c">
          {{ goods.detail.name_c }}
        </p>
        <p class="detail_name">{{ goods.detail.name }}</p>
        <!-- 信息 -->
        <div class="form-box">
          <div class="form-item">
            <div class="form-label">价格：</div>
            <div class="form-con">
              <span style="color: #fff">
                ￥ {{ goods.detail.price ? goods.detail.price : "0.00" }}
              </span>
            </div>
          </div>
          <div class="form-item" v-if="goods.detail.is_up == 0">
            <div class="form-label">标签：</div>
            <div class="form-con">
              <el-input @input="getUpData" @clear="clearInput(goods.detail.grade, 1)" maxlength="3" size="small" clearable v-model="goods.detail.grade" @keyup="
                goods.detail.grade = goods.detail.grade.replace(/[, ]/g, '')
                "></el-input>
            </div>
          </div>
          <div class="form-item" v-else>
            <div class="form-label">等级：</div>
            <div class="form-con">
              <el-select v-model="goods.detail.grade" placeholder="请选择等级" @change="getArmsPrices">
                <el-option v-for=" item  in 
  goods.detail.is_up == 1 &&
    goods.armsGradeOptions.length > 0
    ? goods.armsGradeOptions
    : goods.gradeOptions
" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </div>
          </div>
          <div class="form-item">
            <div class="form-label">背景：</div>
            <div class="form-con">
              <el-select v-model="rankValue" placeholder="请选择背景" @change="rankValueChange">
                <el-option v-for=" item  in  rankOptins " :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </div>
          </div>
          <div class="form-item">
            <div class="form-label">描述：</div>
            <div class="form-con">
              <span style="color: #fff" v-if="goods.detail.marketable == '1'">
                Steam市场可出售
              </span>
              <span style="color: #fff" v-else>Steam市场不可出售</span>
            </div>
          </div>
        </div>
        <div class="btns">
          <el-button style="margin-right: 20px" class="btn-d" size="mini" @click="remove">
            删除
          </el-button>
          <el-button style="margin-left: 20px" type="primary" size="mini" class="btn-s" @click="Topping">
            置顶
          </el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 分享库存弹框 -->
    <finalizeDialog @confirm="finalizeDialogConfirm" @cancel="finalizeDialogCancel" :visible.sync="finalizeDialogShow" />

    <!-- vac封禁 -->
    <vacDialog @cancel="vacDialogCancel" :visible.sync="vacDialogShow" :account-info="accountInfo" :game-list="gameList" />

    <!-- 弹框 -->
    <el-dialog :visible.sync="copyDialogVisible" title="提示" :width="facility == 'pc' ? '400px' : '80%'" append-to-body>
      <div class="">是否跳转到微信分享库存页面?</div>
      <div class="" style="margin-top: 10px;">code码：{{ copyInfo.code || "" }}</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="copyHandle(2)" type="success">复制code码</el-button>
        <el-button @click="copyHandle(1)" type="primary" style="margin-left: 20px !important;">确认跳转</el-button>
      </span>
    </el-dialog>

    <!-- 黑名单弹框 -->
    <DialogBlackList @close="blacklistDialogVisible = false" :visible.sync="blacklistDialogVisible" :type="1" :money="money" />
  </div>
</template>

<script>
import { set, get } from "../utils/tools";
import OSS from "ali-oss";
import draggable from "vuedraggable";
import { glo_loading, loadingSetText } from "../components/loding";
import html2canvas from "html2canvas";
import { domToCanvas } from "modern-screenshot";
import vide from "@/components/vide.vue";
import assessPanel from "./components/assessPanel.vue";
import assessDialog from "./components/assessDialog.vue";
import assessRecord from "./components/assessRecord.vue";
import finalizeDialog from "./components/finalizeDialog.vue";
import vacDialog from "./components/vacDialog.vue";
import DialogBlackList from "@/components/DialogBlackList/DialogBlackList.vue";
import { ColorPicker } from "@/components/colorPicker";
import { mapState } from "vuex";
import MetaInfo from "@/mixins/MetaInfo";
import { getAnchorList, getAnchorDetail } from '@/api/news.js'
import { encoder } from "ali-oss/lib/common/utils/encoder";
import encBase64url from "crypto-js/enc-base64url";
import Clipboard from 'clipboard'
// import {jsonA} from "../utils/data"

import { getPubgTitle, getPubgPass, getPubgSuit, getPubgGoods, getPubgBottom, getCollectionsTitle, getCollectionsCode } from "@/api/finalize.js";
import { getVacInfo, getVacGameList } from "@/api/vac.js";

// 默认标题的文字渐变色
const DEFAULT_GOODS_TITLE_COLOR =
  "linear-gradient(90.0deg,hsla(94,59%,58%,1) 15.8%,hsla(213,64%,54%,1) 61.9%,hsla(198,100%,53%,1) 99.0%)";

export default {
  // mixins: [MetaInfo],
  metaInfo: {
    title: "绝地求生作图工具推荐|pubg吃鸡战绩查询|作图工具推荐|作图教程|库存图分享_闲游盒",
    meta: [
      {
        name: "keywords",
        content: "绝地求生作图工具推荐,pubg吃鸡战绩查询,pubg作图工具推荐,pubg作图教程,pubg库存图分享",
      },
      {
        name: "description",
        content: "闲游盒专注于发布最新游戏攻略动态,内容涉及:绝地求生作图工具推荐/pubg吃鸡战绩查询/pubg作图工具推荐/pubg作图教程/pubg库存图分享等.免费咨询:13145472927(同步VX)",
      },
    ],
  },
  computed: {
    ...mapState(["userInfo", "token", "login", "liveTypes"]),
    filterStyleComputed () {
      // 滤镜计算属性
      return `filter: grayscale(${this.filterStyle.grey}) blur(${this.filterStyle.gass
        }px) sepia(${this.filterStyle.sepia}) saturate(${this.filterStyle.saturation
        }) opacity(${this.filterStyle.opacity}) brightness(${this.filterStyle.brightness
        }) contrast(${this.filterStyle.contrast}) hue-rotate(${this.filterStyle.hueRotate
        }deg) invert(${this.filterStyle.invert * 50}%);`;
    },
  },
  components: {
    draggable,
    vide,
    assessPanel,
    assessDialog,
    assessRecord,
    ColorPicker,
    finalizeDialog,
    vacDialog,
    DialogBlackList,
  },
  data () {
    return {
      facility: "",
      progress: {
        show: true,
        percentage: 0,
      },
      select: {
        options: [
          {
            value: 7,
            label: "中间商品一行显示7个",
            xieStyle: {
              top: "12px",
              right: "-27px",
              width: "48px",
              borderBottom: "30px solid #2C9645",
              borderLeft: "30px solid transparent",
              borderRight: "30px solid transparent",
            },
            xieSpanStyle: {
              top: "6px",
              right: "-2px",
              fontSize: "16px",
            },
            priceFontSize: "font-size: 16px"
          },
          {
            value: 10,
            label: "中间商品一行显示10个",
            xieStyle: {
              top: "8px",
              right: "-18px",
              width: "33px",
              borderBottom: "20px solid #2C9645",
              borderLeft: "20px solid transparent",
              borderRight: "20px solid transparent",
            },
            xieSpanStyle: {
              top: "3px",
              right: "-9px",
              fontSize: "12px",
            },
            priceFontSize: "font-size: 14px"
          },
          {
            value: 12,
            label: "中间商品一行显示12个",
            xieStyle: {
              top: "8px",
              right: "-18px",
              width: "33px",
              borderBottom: "20px solid #2C9645",
              borderLeft: "20px solid transparent",
              borderRight: "20px solid transparent",
            },
            xieSpanStyle: {
              top: "3px",
              right: "-9px",
              fontSize: "12px",
            },
            priceFontSize: "font-size: 12px"
          },
        ],
        value: 7,
        rateSize: sessionStorage.getItem("facility") == "pc" ? "width: calc(100% / 7 - 10px);" : "width: calc(100% / 7 - 5px);",
        goodSize: sessionStorage.getItem("facility") == "pc" ? "width: calc(100% / 7 - 10px);" : "width: calc(100% / 7 - 5px);",
        width: sessionStorage.getItem("facility") == "pc" ? "calc(100% / 7 - 10px)" : "calc(100% / 7 - 5px)",
        bottomSize: "width: 4%;",
        priceFontSize: sessionStorage.getItem("facility") == "pc" ? "font-size: 16px" : "font-size: 12px;",
      },
      contenta: false,
      show3: false,
      fangs: false,
      drag: false,
      dialogVisible: false,
      fontFamilyOptions: [
        {
          label: "绝地求生",
          value: "microsoft yahei",
        },
        {
          label: "绝地求生",
          value: "陈继世行楷",
        },
        {
          label: "绝地求生",
          value: "晨光大字",
        },
        {
          label: "绝地求生",
          value: "汉真广标",
        },
        {
          label: "绝地求生",
          value: "叶根友特隶简体",
        },
        {
          label: "绝地求生",
          value: "建刚草稿体",
        },
        {
          label: "绝地求生",
          value: "钟齐翰墨毛笔",
        },
        {
          label: "绝地求生",
          value: "章草",
        },
      ],
      goods: {
        subtitle: "",
        subprices: "",
        // 初始标题
        oldTitle: {
          fontSzie: 28,
          fontColor: DEFAULT_GOODS_TITLE_COLOR,
          text: "",
          number: "0.00",
          fontFamily: "microsoft yahei",
        },
        // 修改后标题
        newTitle: {
          fontSzie: 28,
          fontColor: DEFAULT_GOODS_TITLE_COLOR,
          text: "",
          number: "0.00",
          fontFamily: "microsoft yahei",
        },
        prices: 0, //总价

        rank: 0, // 等级
        goodList: [],
        arr1: [],
        arr2: [],
        arr3: [],
        arr4: [],
        arrlist: [], // 新的对象代替arr1、arr2、arr3、arr4，因为数据量是不固定的
        arrIndex: "",
        suitData: [], //套装归类
        suitLoding: false,
        suitBtnShow: true,
        suitDataIndex: null,
        listTop: [], //通行证图片
        goodsBjColor: "#000", //背景色
        staging: [], //暂存区
        stagingGroup: [
          {
            name: "site",
            pull: true, //可以拖出
            put: true, //可以拖入
          },
        ],
        library: [], // 素材区

        detail: {}, //详情区
        detailTopShow: true,
        armsGradeOptions: [], // 武器自带的arms价格，如果没有再取gradeOptions
        gradeOptions: [
          {
            value: "Lv1",
            label: "Lv1",
          },
          {
            value: "Lv2",
            label: "Lv2",
          },
          {
            value: "Lv3",
            label: "Lv3",
          },
          {
            value: "Lv4",
            label: "Lv4",
          },
          {
            value: "Lv5",
            label: "Lv5",
          },
          {
            value: "Lv6",
            label: "Lv6",
          },
          {
            value: "Lv7",
            label: "Lv7",
          },
          {
            value: "Lv8",
            label: "Lv8",
          },
          {
            value: "Lv9",
            label: "Lv9",
          },
          {
            value: "Lv满级",
            label: "Lv满级",
          },
        ],
        bottomArr: [], //底部图片
      },
      suitDownloading: false, // 标识是否是套装分类下的下载原图过程，在下载前需要先屏蔽handle-btn类的按钮，否则html2canvas会屏蔽按钮导致页面高度发生变化导致图片缺损
      isImageShow: false,
      loading: false,
      goodsId: null,
      nextGoodsId: null, // 删除、置顶前记录下一个id
      visible: false,
      isGrade: true, //标签
      isPrice: true, //价格
      TotalPrice: true, //总价
      loadingText: "",
      classid: "",
      form: {
        hide: 1,
        // steam_id: '76561199071471934',
        // steam_id: 'woJ4be8L88L3t6uGLqxBzEuJ+mcLNGlpNBjziSxHl9Y=',
        steam_id: "",
        number: "5000",
      },
      goodsIndex: null,
      bjvisible: false,
      filtervisible: false, // 滤镜弹窗显示
      filterStyle: {
        // 滤镜弹窗的样式控制
        grey: 0, // 灰度
        gass: 0, // 高斯模糊
        sepia: 0, // 深褐色
        saturation: 1, // 饱和度
        opacity: 1, // 透明度
        brightness: 1, // 亮暗度
        contrast: 1, // 对比度
        hueRotate: 0, // 色相转换
        invert: 0, // 反转
      },
      forma: {},
      y: 0,
      scrollY: "", //距离顶高度
      pageX: "", //页面宽度
      loopImg: 1,
      zLoopImg: 1,
      lastLoopImg: 0,
      shopMsg: {
        num: 0,
        length: 0,
      },
      rankValue: "",
      rankOptins: [
        {
          label: "普通",
          value: "0",
        },
        {
          label: "特殊",
          value: "1",
        },
        {
          label: "稀有",
          value: "2",
        },
        {
          label: "精英",
          value: "3",
        },
        {
          label: "史诗",
          value: "4",
        },
        {
          label: "传说",
          value: "5",
        },
      ],
      collections_id: 0,
      collipsePanel: false, // 是否收起首页的悬浮工具栏
      settingCollipse: false, // 设置的是否折叠，记录用，页面往上拉再下拉后保留之前的折叠状态
      showGoodsName: true, // 显示隐藏商品行名称
      show4: false, // 展示素材区面板
      originLibraryList: [], // 原始的素材库内容，方便再次查询的时候初始化素材库面板
      show5: true, // 展示主播区面板
      showSteamerDetail: false, // 展示主播详情
      steamerDetail: {},
      originSteamerList: [], // 原始的主播区内容
      tempContentList: [],
      drawSrc: '', // 原图下载的hover图片
      disabled: true,
      timer: null,

      thumbnailGoodsList: [], // 缩略图列表
      finalizeDialogShow: false,// 分享库存弹框
      finalizeSubmitForm: {}, // 分享库存弹框form表单
      isAutomaticSetType: true, // 是否可以自动排版
      isCheckId: 0, // 选中id
      isVacSearch: false,
      vacDialogShow: false,
      accountInfo: {},
      gameList: [],
      copyDialogVisible: false,
      copyInfo: {
        id: "",
        code: "",
      },
      blacklistDialogVisible: false,
      money: "",
    };
  },
  created () {
    document.body.ondrop = function (event) {
      event.preventDefault();
      event.stopPropagation();
    };
    this.facility = sessionStorage.getItem("facility");
    if (document.documentElement.clientWidth < 900) {
      this.goods.oldTitle.fontSzie = 18;
    } else {
      this.goods.oldTitle.fontSzie = 28;
    }
    this._collection_title = "";
    // this.getInit()
  },
  watch: {
    $route: {
      handler (route) {
        if (route.path == "/" && this.collections_id) {
          setTimeout(() => {
            this.toContent();
          }, 100);
        }
      },
      deep: true,
    },
    goodsId: function (val) {
      this.$nextTick(() => {
        this.handleScroll();
      });
    },
    // 监听 goods.newTitle.fontFamily
    // 数据变化的时候动态更改 字体样式选择框 input 的 font-family
    "goods.newTitle.fontFamily": function (value) {
      this.$refs.FontFamilySelect.$refs.reference.$el.style = `font-family: ${value};`;
    },
    liveTypes: {
      handler: function (val) {
        if (val) {
          this.isPrice = false;
        } else {
          this.isPrice = true;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  mounted () {
    // 监听高度
    this.$nextTick(() => {
      window.addEventListener("scroll", this.handleScroll);
    });

    let pageX = document.documentElement.clientWidth;
    this.pageX = pageX;

    this.initBanner()
    this.initAnchorList()

    // setTimeout(() => {
    //   this.sumbit({
    //     hide: 1,
    //     number: 2000,
    //     steam_id: "76561199168757980"
    //   })
    // }, 1000);
  },
  activated () {
    if (this.login == 1) {
      // 从个人中心退出登录过来，要清掉采集信息
      this.$refs.video ? this.$refs.video.clearSteamId() : null;
      this.isImageShow = false;
      this.goods.suitLoding = false;
      this.form.hide = 1;
      this.form.steam_id = "";
      this.form.number = "5000";
      this.shopMsg.num = 0;
      this.goodsId = null;
      // this.goods.arr1 = [];
      // this.goods.arr2 = [];
      // this.goods.arr3 = [];
      // this.goods.arr4 = [];
      this.goods.arrlist = [];
      this.goods.suitData = [];
      this.goods.listTop = [];
      this.goods.bottomArr = [];
      this.goods.staging = [];
      this.goods.library = [...this.originLibraryList];
    }
    this.handleScroll();
  },
  methods: {
    // 背景颜色
    myDotBgColor (index) {
      let steamId = get(this.form.steam_id);
      let sliceSteamId = steamId.substr(steamId.length - (6 - index), 1);
      return sliceSteamId;
    },
    // 数字
    myDotNumber () {
      // let steamId = get(this.form.steam_id);
      // let sliceSteamId = steamId.substr(11), sliceSteamIdStr = "";
      // for (let index = 0; index < sliceSteamId.length; index++) {
      //   let number = Number(sliceSteamId[index]) + 1;
      //   sliceSteamIdStr += `${number == 10 ? 0 : number}`;
      // }
      let collectionsId = this.collections_id || "";
      if (collectionsId.length > 7) {
        collectionsId = collectionsId.slice(collectionsId.length - 7);
      }
      return collectionsId ? `NO.${collectionsId}` : "";
    },
    // 自动排版
    automaticSetType () {
      glo_loading.loadingSetText(`正在进行自动排版...`);
      let select = JSON.stringify(this.$options.data().select),
        goodsList = this.goods.arrlist.flat(Infinity), suitList = this.goods.suitData || [], rarityGoodsList = [], priceGoodsList = [], sortPriceGoodsList = [], noPriceGoodsList = [];
      rarityGoodsList = goodsList.filter(ele => ele.rarity != "0");
      rarityGoodsList.forEach(ele => ele.checked = false);
      if (rarityGoodsList.length)
        suitList = [{ name: "稀有物品", list: rarityGoodsList, isCheck: false, select: JSON.parse(select) }, ...suitList];

      priceGoodsList = goodsList.filter(ele => ele.price > 0 && ele.rarity == "0");
      sortPriceGoodsList = priceGoodsList.sort(this.compare("price"));

      noPriceGoodsList = goodsList.filter(ele => ele.price == 0 && ele.rarity == "0");

      let sortPrice = sortPriceGoodsList.reduce((prev, cur) => {
        return prev + cur.price;
      }, 0);

      if (sortPriceGoodsList.length)
        suitList = [...suitList, { name: `价值物品(￥${sortPrice.toFixed(2)})`, list: sortPriceGoodsList, isCheck: false, select: JSON.parse(select) }];

      this.$set(this.goods, "suitData", suitList);

      this.$set(this.goods, "arrlist", this.handleData(noPriceGoodsList));

      this.isAutomaticSetType = false;
      setTimeout(() => {
        glo_loading.loadingHide();
        this.$message({ type: "success", message: "自动排版完成" });
      }, 500);
    },
    // 排序
    compare (property) {
      return function (a, b) {
        var value1 = a[property];
        var value2 = b[property];
        return value2 - value1;
      }
    },
    // 处理数据
    handleData (list, num = 560) {
      let listLength = list.length;
      let lineNumber = listLength % num === 0 ? listLength / num : Math.floor((listLength / num) + 1);
      let newList = [];
      for (let i = 0; i < lineNumber; i++) {
        let temp = list.slice(i * num, i * num + num);
        newList.push(JSON.parse(JSON.stringify(temp)));
      }
      return newList;
    },
    // 确认分享库存
    finalizeDialogConfirm (form) {
      if (this.progress.percentage < 100) {
        return this.$message({ type: "warning", message: "还有商品未加载完成，请等待..." });
      }
      this.finalize(form);
    },
    // 关闭分享库存弹框
    finalizeDialogCancel () {
      this.finalizeDialogShow = false;
    },
    // 生成分享库存
    async finalize (ruleForm) {
      try {
        glo_loading.loadingShow("正在生成分享库存...");
        let goods = this.goods, form = this.form;

        // 标题
        let pubgTitleRes = await getPubgTitle({
          token: this.token,
          steam_id: form.steam_id,
          title: goods.newTitle.text,
          name: ruleForm.title,
          describe: ruleForm.desc,
          price: goods.prices,
          grade: goods.rank + "级",
          rank: goods.is_captain ? "PLUS+已激活" : "免费版",
          rows: this.select.value,
        });
        // console.log(pubgTitleRes);
        if (pubgTitleRes.code == 0) {
          return this.$message.error(pubgTitleRes.msg);
        }

        // 通行证
        let passList = this.goods.listTop.map((ele, index) => {
          return { name: ele.name, pic_image: ele.pic_image, weigh: this.goods.listTop.length - index }
        });
        let pubgPassRes = passList.length ? await getPubgPass({
          token: this.token,
          pubg_title_id: pubgTitleRes.data,
          steam_id: form.steam_id,
          pass_list: passList,
        }) : 0;
        // console.log(pubgPassRes);
        if (pubgPassRes.code == 0) {
          return this.$message.error(pubgPassRes.msg);
        }

        // 套装
        let suitListLength = goods.suitData.reduce((a, b) => a.concat(b.list), []).length;
        let suitList = goods.suitData.map((ele, index) => {
          let number = 0;
          goods.suitData.map((eles, indexs) => {
            if (index > indexs) {
              number += eles.list.length;
            }
          });
          return {
            name: ele.name,
            weigh: goods.suitData.length - index,
            rows: ele.select.value,
            list: ele.list.map((item, ind) => {
              return {
                name: item.name,
                name_c: item.name_c,
                price: item.price,
                pic_image: `${item.pic_image?.includes('https') ? '' : this.config.imageUrl}${item.pic_image}`,
                // pic_image: item.pic_image,
                rarity: item.rarity,
                marketable: item.marketable,
                level: item.is_up == 1 ? (item.grade.indexOf("满级") != -1 ? item.max_grade : Number(parseFloat(item.grade) || 0)) : 0,
                is_up: item.is_up,
                classid: item.myClassId || item.classid,
                grade: item.is_up == 1 ? item.grade : (item.grade.indexOf("Lv") == -1 ? item.grade : item.grade.replace("Lv", "")),
                number: item.number,
                weigh: !index ? Number(suitListLength - ind) : Number(suitListLength - number - ind),
              }
            })
          }
        });
        // console.log(suitList);
        let pubgSuitRes = suitList.length ? await getPubgSuit({
          token: this.token,
          pubg_title_id: pubgTitleRes.data,
          steam_id: form.steam_id,
          suit_list: JSON.stringify(suitList),
        }) : 0;
        // console.log(pubgSuitRes);
        if (pubgSuitRes.code == 0) {
          return this.$message.error(pubgSuitRes.msg);
        }

        // // 中间商品
        let centerList = this.mapData(goods.arrlist);
        // console.log(centerList);
        let pubgCenterRes = centerList.length ? await getPubgGoods({
          token: this.token,
          pubg_title_id: pubgTitleRes.data,
          steam_id: form.steam_id,
          goods_list: JSON.stringify(centerList),
        }) : 0;

        // console.log(pubgCenterRes);
        if (pubgCenterRes.code == 0) {
          return this.$message.error(pubgCenterRes.msg);
        }

        // 小商品
        let bottomList = goods.bottomArr.map((ele, index) => {
          return {
            name: ele.name,
            name_c: ele.name_c,
            price: ele.price,
            pic_image: `${ele.pic_image?.includes('https') ? '' : this.config.imageUrl}${ele.pic_image}`,
            // pic_image: ele.pic_image,
            rarity: ele.rarity,
            marketable: ele.marketable,
            level: ele.is_up == 1 ? (ele.grade.indexOf("满级") != -1 ? ele.max_grade : Number(parseFloat(ele.grade) || 0)) : 0,
            is_up: ele.is_up,
            classid: ele.myClassId || ele.classid,
            grade: ele.is_up == 1 ? ele.grade : (ele.grade.indexOf("Lv") == -1 ? ele.grade : ele.grade.replace("Lv", "")),
            number: ele.number,
            weigh: goods.bottomArr.length - index,
          }
        })
        // console.log(bottomList);
        let pubgBottomRes = bottomList.length ? await getPubgBottom({
          token: this.token,
          pubg_title_id: pubgTitleRes.data,
          steam_id: form.steam_id,
          bottom_list: JSON.stringify(bottomList),
        }) : 0;
        // console.log(pubgBottomRes);
        if (pubgBottomRes.code == 0) {
          return this.$message.error(pubgBottomRes.msg);
        }

        if (pubgTitleRes.code == 1 && pubgPassRes ? pubgPassRes.code : 1 && pubgSuitRes ? pubgSuitRes.code : 1 && pubgCenterRes ? pubgCenterRes.code : 1 && pubgBottomRes ? pubgBottomRes.code : 1) {
          this.finalizeDialogShow = false;
          glo_loading.loadingHide();
          this.$message({ type: "success", message: "已成功生成微信分享库存" });

          // setTimeout(() => {
          //   this.$confirm("是否跳转到微信分享库存页面?", "提示", {
          //     confirmButtonText: "确定",
          //     cancelButtonText: "复制code码",
          //     type: "success"
          //   }).then(() => {
          //     let id = `${encodeURIComponent(set(pubgTitleRes.data))}`, { href } = this.$router.resolve({ name: "finalize", query: { id } });
          //     if (this.facility == "pc") {
          //       window.open(href, "_blank");
          //     } else {
          //       this.$router.push(`/finalize?id=${id}`);
          //     }
          //   }).catch(() => {
          //     this.$copyText(location.href).then(() => {
          //       this.$message.success("复制成功");
          //     }).catch(() => {
          //       this.$message.error("复制失败");
          //     });
          //   });
          // }, 500);

          // 标题
          setTimeout(async () => {
            let titleRes = await getCollectionsTitle({ pubg_title_id: set(pubgTitleRes.data) });
            console.log(titleRes);
            if (titleRes.code == 1) {
              let titleData = titleRes.data || {}, code = "";
              if (!titleData.code) {
                let data = {
                  pubg_title_id: set(pubgTitleRes.data),
                }
                code = await getCollectionsCode(data).then(res => {
                  // console.log(res);
                  return res.data;
                })
              } else {
                code = titleData.code;
              }
              this.copyInfo = {
                id: pubgTitleRes.data,
                code,
              };
              this.copyDialogVisible = true;
            }
          }, 500);
        } else {
          glo_loading.loadingHide();
          this.$message({ type: "error", message: "微信分享库存失败" });
        }
      } catch (error) {
        glo_loading.loadingHide();
        this.$message({ type: "error", message: "微信分享库存失败" });
      }
    },
    // 遍历数组
    mapData (data) {
      let number = data.reduce((a, b) => a.concat(b), []).length;
      return data.map((ele, index) => {
        return ele.map((item, ind) => {
          return {
            name: item.name,
            name_c: item.name_c,
            price: item.price,
            pic_image: `${item.pic_image?.includes('https') ? '' : this.config.imageUrl}${item.pic_image}`,
            // pic_image: item.pic_image,
            rarity: item.rarity,
            marketable: item.marketable,
            level: item.is_up == 1 ? (item.grade.indexOf("满级") != -1 ? item.max_grade : Number(parseFloat(item.grade) || 0)) : 0,
            is_up: item.is_up,
            classid: item.myClassId || item.classid,
            grade: item.is_up == 1 ? item.grade : (item.grade.indexOf("Lv") == -1 ? item.grade : item.grade.replace("Lv", "")),
            number: item.number,
            weigh: !index ? Number(number - ind) : Number(number - index * 560 - ind),
          }
        })
      })
    },

    copyHandle (type) {
      if (type == 1) {
        let id = `${encodeURIComponent(set(this.copyInfo.id))}`, { href } = this.$router.resolve({ name: "finalize", query: { id } });
        if (this.facility == "pc") {
          window.open(href, "_blank");
        } else {
          this.$router.push(`/finalize?id=${id}`);
        }
      } else {
        this.$copyText(this.copyInfo.code).then(() => {
          this.$message.success("复制成功");
        }).catch(() => {
          this.$message.error("复制失败");
        });
      }
    },

    // 查询封禁
    async searchVac () {
      if (this.$store.state.login == 1) {
        this.$message({
          message: "请先进行登录",
          type: "warning",
        });
        this.$store.commit("setLoginShow", 1);
        return;
      }

      // this.vacDialogShow = true;

      try {
        if (this.isVacSearch) return this.vacDialogShow = true;

        this.accountInfo = {};
        this.gameList = [];

        glo_loading.loadingShow("查询中...");

        let data = {
          steam_id: this.form.steam_id,
          token: this.token,
        }

        let vacInfoRes = await getVacInfo(data);

        if (vacInfoRes.code == 1) {
          let vacInfo = vacInfoRes.data?.vac?.players[0], userInfo = vacInfoRes.data?.user?.response?.players?.player[0];
          this.accountInfo = {
            avatarfull: userInfo.avatarfull,
            personaname: userInfo.personaname,
            VACBanned: vacInfo.VACBanned,
            NumberOfVACBans: vacInfo.NumberOfVACBans,
            NumberOfGameBans: vacInfo.NumberOfGameBans,
            DaysSinceLastBan: vacInfo.DaysSinceLastBan,
            CommunityBanned: vacInfo.CommunityBanned,
            timecreated: this.getFormatDate(userInfo.timecreated),
          };
        } else {
          glo_loading.loadingHide();
        }

        let vacGameRes = await getVacGameList(data);
        if (vacGameRes.code == 1) {
          this.gameList = vacGameRes.data?.response?.games;
        } else {
          glo_loading.loadingHide();
        }

        if (vacInfoRes.code == 1 && vacGameRes.code == 1) {
          glo_loading.loadingHide();
          this.vacDialogShow = true;
          this.isVacSearch = true;
        }
      } catch (error) {
        this.vacDialogShow = true;
      }
    },

    // 转换时间格式
    getFormatDate (timestamp) {
      let date = new Date(timestamp * 1000);
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      let hour = date.getHours();
      let minutes = date.getMinutes();
      let seconds = date.getSeconds();
      month = (month < 10) ? "0" + month : month;
      day = (day < 10) ? "0" + day : day;
      hour = (hour < 10) ? "0" + hour : hour;
      minutes = (minutes < 10) ? "0" + minutes : minutes;
      seconds = (seconds < 10) ? "0" + seconds : seconds;
      let currentDate = year + "-" + month + "-" + day
        + " " + hour + ":" + minutes + ":" + seconds;
      return currentDate;
    },

    // 关闭vac弹框
    vacDialogCancel () {
      this.vacDialogShow = false;
    },

    // 置顶
    shopTopping (ele, index) {
      if (index == 0) {
        return this.$message({ type: "warning", message: "已经在最上面了" });
      }
      let array = this.goods.suitData;
      array.unshift(array.splice(index, 1)[0])
      this.goods.suitData = array;
    },

    // 多选框显示
    shopCheck (ele, index) {
      this.isCheckId = ele.id;
      let suitList = this.goods.suitData;
      suitList.forEach((item, ind) => {
        if (index == ind) {
          item.list.forEach(it => {
            it.checked = true;
          })
          this.$set(this.goods.suitData, index, { ...item, ...{ isCheck: !ele.isCheck } });

          this.getDetail(1, ele.list[0], 0, "套装", ele, index);
        } else {
          this.$set(this.goods.suitData[ind], "isCheck", false);
        }
      })
    },

    // 设置一行显示条数
    handleCommand (command, ele, index) {
      let xieList = document.querySelectorAll(`.item_top_right_xie${index}`),
        xieSpanList = document.querySelectorAll(`.item_top_right_xie_span${index}`);
      let facility = sessionStorage.getItem("facility"),
        findIndex = ele.select.options.findIndex(ele => ele.value == command),
        selectObj = ele.select.options[findIndex];

      let goodSize = facility == "pc" ? `width: calc(100% / ${selectObj.value} - 10px);` : "width: calc(100% / 7);";

      this.$set(this.goods.suitData[index].select, "value", command);
      this.$set(this.goods.suitData[index].select, "goodSize", goodSize);
      this.$set(this.goods.suitData[index].select, "priceFontSize", selectObj.priceFontSize);

      for (let i = 0; i < xieList.length; i++) {
        let xieObj = xieList[i];
        xieObj.style.top = selectObj.xieStyle.top;
        xieObj.style.right = selectObj.xieStyle.right;
        xieObj.style.width = selectObj.xieStyle.width;
        xieObj.style.borderBottom = selectObj.xieStyle.borderBottom;
        xieObj.style.borderLeft = selectObj.xieStyle.borderLeft;
        xieObj.style.borderRight = selectObj.xieStyle.borderRight;
      }

      for (let i = 0; i < xieSpanList.length; i++) {
        let xieSpanObj = xieSpanList[i];
        xieSpanObj.style.top = selectObj.xieSpanStyle.top;
        xieSpanObj.style.right = selectObj.xieSpanStyle.right;
        xieSpanObj.style.fontSize = selectObj.xieSpanStyle.fontSize;
      }
    },

    initBanner () {
      const _this = this
      let param = {
        substation_id: set(_this.config.substationId),
      };
      _this.$indexPost("/getBanner", param).then((res) => {
        // 网站信息
        _this.drawSrc = res.draw;
        _this.money = res.black_fee || 0;
        _this.$store.commit('setOrderTypes', res.order)
      });
    },
    progressFormat (e) {
      return "商品加载中：" + e + "%";
    },
    getSpanColor (item) {
      if (this.isPrice === true && item.marketable == "1") {
        return "color:#2c9645";
      } else if (this.isPrice === true && item.marketable == "0") {
        return "color:#ff5959";
      } else {
        return "color:rgba(0,0,0,0)";
      }
    },
    moveTop (index) {
      if (index == 0) {
        this.$message({
          message: "已经在最上面了",
          type: "warning",
        });
        return false;
      }
      let arr = this.goods.suitData;
      arr.splice(index - 1, 1, ...arr.splice(index, 1, arr[index - 1]));
      this.goods.suitData = arr;
    },
    suitDelete (index) {
      let arr = this.goods.suitData[index].list;
      this.goods.suitData.splice(index, 1);
      if (this.goods.arrlist.length == 0) {
        this.goods.arrlist = [[]];
      }
      arr.map((item) => {
        this.goods.arrlist[0].unshift(item);
      });
    },
    moveBottom (index) {
      let arr = this.goods.suitData;
      if (index == arr.length - 1) {
        this.$message({
          message: "已经再最下面了",
          type: "warning",
        });
        return false;
      }
      arr.splice(index, 1, ...arr.splice(index + 1, 1, arr[index]));
      this.goods.suitData = arr;
    },
    // 套装归类
    async suit (type) {
      if (!this.isAutomaticSetType) {
        return this.$message({ type: "warning", message: type == 1 ? "请勿重复进行自动排版" : "已有套装归类，请勿重复进行套装归类" });
      }
      if (type == 1) {
        if (this.progress.percentage < 100) {
          return this.$message({ type: "warning", message: "还有商品未加载完成，请等待..." });
        }
      }
      this.goods.suitLoding = true;
      if (!this.form.steam_id) {
        this.$message({
          message: "请先输入steam账号",
          type: "warning",
        });
        return false;
      }

      glo_loading.loadingShow(`正在查询套装...`);
      let arrs = [];
      this.goods.suitData.map((item) => {
        if (item.name == "商品行") {
          arrs.push(item);
        }
      });
      let param = {
        steam_id: this.form.steam_id,
        arr: arrs,
      };
      this.$indexPost("/getSuit", param).then((res) => {
        if (res.list.length < 1) {
          this.$message({
            message: "暂无套装",
            type: "warning",
          });
          // 自动排版
          if (type == 1) {
            this.automaticSetType();
          } else {
            glo_loading.loadingHide();
          }
          return false;
        } else {
          let data = res.list, suitData = [];
          data.forEach(ele => {
            ele.isCheck = false;
            ele.list.forEach(item => item.checked = false)
          })
          glo_loading.loadingSetText(`正在进行套装归类...`);

          data.map(item => suitData.push(Object.assign(item, { select: JSON.parse(JSON.stringify(this.$options.data().select)) })));
          console.log(suitData);
          this.goods.suitData = suitData;
          for (let i = 0; i < this.goods.arrlist.length; i++) {
            res.list.map((item) => {
              let newd = this.findSame(item.list, this.goods.arrlist[i]);
              this.goods.arrlist[i] = newd;
            });
          }
          if (this.goods.staging.length > 0) {
            res.list.map((item) => {
              let newd = this.findSame(item.list, this.goods.staging);
              this.goods.staging = newd;
            });
          }
          if (this.goods.library.length > 0) {
            res.list.map((item) => {
              let newd = this.findSame(item.list, this.goods.library);
              this.goods.library = newd;
            });
          }

          // 自动排版
          if (type == 1) {
            this.automaticSetType();
          } else {
            glo_loading.loadingHide();
          }
        }
      });
    },
    findSame (arr1, arr2) {
      let add = [];
      add = arr2.filter((item) => !arr1.some((ele) => ele.id === item.id));
      return add;
    },
    filterGrade (grade) {
      let val = "";

      if (grade && grade.indexOf && grade.indexOf("Lv")) {
        val = "Lv" + grade;
      } else {
        val = grade;
      }
      return val;
    },
    // 查询
    async sumbit (val) {
      this.collections_id = 0;
      this.isVacSearch = false;
      // 每次查询重置isImageShow=false，避免重复查询时点击下载不走图片加载完的验证
      this.isAutomaticSetType = true;
      this.isImageShow = false;
      this.goods.suitLoding = false;
      this.form.hide = val.hide;
      this.form.steam_id = set(val.steam_id);
      this.form.number = val.number;
      this.shopMsg.num = 0;
      this.goodsId = null;
      // this.goods.arr1 = [];
      // this.goods.arr2 = [];
      // this.goods.arr3 = [];
      // this.goods.arr4 = [];
      this.goods.arrlist = [];
      this.goods.suitData = [];
      this.goods.listTop = [];
      this.goods.bottomArr = [];
      this.goods.staging = [];
      this.goods.library = [...this.originLibraryList];

      try {
        if (!this.form.steam_id) {
          this.$message({
            message: "请先输入setam账号",
            type: "warning",
          });
          return false;
        }

        // glo_loading,loadingSetText
        glo_loading.loadingShow("库存正在获取中...");

        const data = await this.$indexPost("/collections_check", this.form);
        //等级
        const data2 = await this.$indexPost("/collections_grade", this.form);
        //通行证
        const data3 = await this.$indexPost("/collections_top", this.form);
        //底部
        const data1 = await this.$indexPost("/collections_bottom", this.form);

        if (data.code == 0) {
          this.$message({
            message: data.msg,
            type: "warning",
          });
        }

        const list = data.list.data;
        this.goods.subtitle = data.collection_subtitle;
        this.goods.subprices = data.collection_subtitle;
        const listLenght = data.list.number;

        this.goods.arrlist = [];

        for (let key in list) {
          this.goods.arrlist.push(list[key]);
        }
        this.goods.rank = data2.rank;
        this.goods.is_captain = data2.is_captain;
        //升级武器等级遍历
        // var counts = data2.weapons_count;
        // if (counts > 0) {
        //   var weapons = data2.weapons;
        //   for (var i = 0; i < counts; i++) {
        //     if (weapons[i]["grade"] && weapons[i]["grade"] != "1") {
        //       this.goods.arrlist[0][i]["grade"] = weapons[i]["grade"];
        //     }
        //   }
        // }
        let weapons = data2.weapons;
        let arrList = this.goods.arrlist[0];
        weapons.forEach(ele => {
          let findIndex = arrList.findIndex(item => item.name == ele.name && item.classid == ele.classid);
          if (findIndex != -1) {
            this.$set(this.goods.arrlist[0][findIndex], "grade", ele.grade);
            this.$set(this.goods.arrlist[0][findIndex], "max_grade", ele.grade_number || 10);
          }
        })

        this.goods.oldTitle.text = data.collection_title;
        this.goods.newTitle.text = data.collection_title;
        this._collection_title = data.collection_title;
        // let last_page = data.list.last_page
        // this.goods.arrs = list
        // this.goods.arrs = this.arrChange(5, list)

        this.goods.listTop = data3.data;
        this.goods.bottomArr = data1.data;

        //添加用户采集记录
        if (this.$store.state.login == 0) {
          this.addUserCollections();
        } else {
          this.getPrices();
        }

        // 初始化素材区资源
        this.initLibraryList();

        this.$nextTick(() => {
          this.isImage();
        });
      } catch {
        glo_loading.loadingHide();
      }
    },
    // 输入框为0清空输入框
    moneyFocus () {
      if (this.goods.detail.price == 0) {
        this.goods.detail.price = 0.0;
      }
    },
    // 修改商品行显示数量
    selectChange (e) {
      let xieList = document.querySelectorAll(".good_item_top_right_xie"),
        xieSpanList = document.querySelectorAll(".good_item_top_right_xie_span");
      let facility = sessionStorage.getItem("facility"),
        findIndex = this.select.options.findIndex(ele => ele.value == e),
        selectObj = this.select.options[findIndex];

      // this.select.rateSize = facility == "pc" ? `width: calc(100% / ${selectObj.value} - 10px);` : "width: calc(100% / 5 - 10px);";
      this.select.goodSize = facility == "pc" ? `width: calc(100% / ${selectObj.value} - 10px);` : "width: calc(100% / 7);";
      this.select.priceFontSize = selectObj.priceFontSize;

      for (let i = 0; i < xieList.length; i++) {
        let xieObj = xieList[i];
        xieObj.style.top = selectObj.xieStyle.top;
        xieObj.style.right = selectObj.xieStyle.right;
        xieObj.style.width = selectObj.xieStyle.width;
        xieObj.style.borderBottom = selectObj.xieStyle.borderBottom;
        xieObj.style.borderLeft = selectObj.xieStyle.borderLeft;
        xieObj.style.borderRight = selectObj.xieStyle.borderRight;
      }

      for (let i = 0; i < xieSpanList.length; i++) {
        let xieSpanObj = xieSpanList[i];
        xieSpanObj.style.top = selectObj.xieSpanStyle.top;
        xieSpanObj.style.right = selectObj.xieSpanStyle.right;
        xieSpanObj.style.fontSize = selectObj.xieSpanStyle.fontSize;
      }

      return;
      if (e == 10) {
        this.select.rateSize = sessionStorage.getItem("facility") == "pc" ? "width: calc(100% / 10 - 10px);" : "width: calc(100% / 5 - 10px);";
        this.select.goodSize = sessionStorage.getItem("facility") == "pc" ? "width: calc(100% / 10 - 10px);" : "width: calc(100% / 7);";
        this.select.bottomSize = "width: 3%;";

        for (let i = 0; i < xie.length; i++) {
          const e = xie[i];
          e.style.top = "8px";
          e.style.borderBottom = "20px solid #2C9645";
          e.style.borderLeft = "20px solid transparent";
          e.style.borderRight = "20px solid transparent";
          e.style.width = "33px";
          e.style.right = "-18px";
        }
        for (let i = 0; i < xieSpan.length; i++) {
          const e = xieSpan[i];
          e.style.top = "3px";
          e.style.fontSize = "12px";
          e.style.right = "-9px";
        }
      }
      if (e == 7) {
        this.select.rateSize = sessionStorage.getItem("facility") == "pc" ? "width: calc(100% / 7 - 10px);" : "width: calc(100% / 5 - 10px);";
        this.select.goodSize = sessionStorage.getItem("facility") == "pc" ? "width: calc(100% / 7 - 10px);" : "width: calc(100% / 7);";
        this.select.bottomSize = "width: 4%;";
        for (let i = 0; i < xie.length; i++) {
          const e = xie[i];
          e.style.top = "12px";
          e.style.borderBottom = "30px solid #2C9645";
          e.style.borderLeft = "30px solid transparent";
          e.style.borderRight = "30px solid transparent";
          e.style.width = "48px";
          e.style.right = "-27px";
        }
        for (let i = 0; i < xieSpan.length; i++) {
          const e = xieSpan[i];
          e.style.top = "6px";
          e.style.fontSize = "16px";
          e.style.right = "-2px";
        }
      }
      if (e == 5) {
        this.select.size = "width: calc(20% - 12px);";
        this.select.bottomSize = "width: 5%;";
      }
    },
    // 拖拽开始
    onStart (e) {
      this.drag = true;
    },
    // 拖拽结束
    onEnd () {
      this.drag = false;
      // this.initializationArr()
    },
    // 图片加载完成
    successLoadImg () {
      let num = 0;
      ++this.shopMsg.num;
      if (!this.goods.suitLoding) {
        glo_loading.loadingSetText(
          `正在获取库存数量：${Math.floor(this.shopMsg.num / 2)}/${this.shopMsg.length
          }`
        );
      }
      if (this.shopMsg.length > 200) {
        num = Math.floor(this.shopMsg.length / 100);
        this.progress.percentage = Math.floor(this.shopMsg.num / num);
      } else {
        this.progress.percentage = 100;
      }
      if (this.shopMsg.num == 400) {
        glo_loading.loadingHide();
        this.toContent();
      } else if (
        this.shopMsg.num == this.shopMsg.length &&
        this.shopMsg.num < 400
      ) {
        glo_loading.loadingHide();
        this.toContent();
      }
    },
    // 输入框清空
    clearInput (val, type) {
      if (type == 0) {
        this.goods.detail.describe = "";
      }
      if (type == 1) {
        this.goods.detail.grade = 0;
      }
      if (type == 2) {
        this.goods.detail.price = 0;
      }
      this.getUpData();
    },
    // 置顶
    toTop () {
      window.scrollTo({
        top: document.getElementById("video").offsetHeight,
        behavior: "smooth",
      });
    },
    // 去商品区域
    toContent () {
      let topHight = document.getElementById("video").offsetHeight;
      window.scrollTo({
        top: topHight,
        behavior: "smooth",
      });
      setTimeout(() => {
        this.blacklistDialogVisible = this.goods.subprices ? true : false;
      }, 500);
    },
    // 右侧漂浮
    handleScroll () {
      this.scrollY =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.getScroll(this.pageX, this.scrollY);
    },
    getScroll (pageX, pageH) {
      this.$nextTick(() => {
        try {
          let topHight = document.getElementById("video").offsetHeight;
          let menu = document.querySelector(".menus");
          let scrollRight = document.querySelector(".goods_pc_right");
          let scrollLeft = document.querySelector(".goods_pc_left");
          let assessLeft = document.querySelector(".assess-pc-left");
          let assessRecord = document.querySelector(".assess-pc-record");
          let priceLeft = document.querySelector(".price_left");
          let scrollTop = document.querySelector(".to_top");
          let progress = document.querySelector(".progress-box");
          let steamerRight = document.querySelector(".goods_pc_anchor_right");
          if (
            this.goods.arrlist.length > 0 &&
            this.goods.arrlist[0].length > 0
          ) {
            if (pageX > 900) {
              // PC端
              if (pageH >= topHight) {
                this.collipsePanel = this.settingCollipse;
                menu ? (menu.style.position = "fixed") : "";
                menu ? (menu.style.margin = "0 auto") : "";
                menu ? (menu.style.top = "60px") : "";
                menu ? (menu.backgroundColor = "#f3f3f3") : "";
                this.contenta = true;
                scrollRight ? (scrollRight.style.position = "fixed") : "";
                scrollRight ? (scrollRight.style.right = "1%") : "";
                scrollRight ? (scrollRight.style.top = "125px") : "";
                scrollLeft ? (scrollLeft.style.position = "fixed") : "";
                scrollLeft ? (scrollLeft.style.left = "20px") : "";
                scrollLeft
                  ? (scrollLeft.style.top = `${menu.offsetTop + menu.offsetHeight + 15
                    }px`)
                  : "";
                assessLeft ? (assessLeft.style.position = "fixed") : "";
                assessLeft ? (assessLeft.style.left = "20px") : "";
                assessLeft
                  ? (assessLeft.style.top = `${menu.offsetTop + menu.offsetHeight + 440
                    }px`)
                  : "";
                assessRecord ? (assessRecord.style.position = "fixed") : "";
                assessRecord ? (assessRecord.style.left = "20px") : "";
                assessRecord
                  ? (assessRecord.style.top = `${menu.offsetTop +
                    menu.offsetHeight +
                    10 +
                    assessLeft.offsetHeight +
                    440
                    }px`)
                  : "";
                // 估价记录高度减去估价面板的高度及距顶，减去上下间隔各10px
                if (assessRecord) {
                  let assessLeftNew = "";
                  if (assessLeft) {
                    assessLeftNew = `calc(100vh - ${parseInt(assessLeft.style.top) + parseInt(assessLeft.offsetHeight) + 10 + 10}px)`;
                  } else if (scrollLeft) {
                    assessLeftNew = `calc(100vh - ${parseInt(scrollLeft.style.top) + parseInt(scrollLeft.offsetHeight) + 10 + 10}px)`;
                  } else {
                    assessLeftNew = `calc(100vh - ${menu.offsetTop + menu.offsetHeight + 15}px)`;
                  }
                  if (assessRecord.style.height != assessLeftNew) {
                    this.$refs.assessRecord
                      ? this.$refs.assessRecord.reload()
                      : null;
                  }
                  assessRecord.style.height = assessLeftNew;
                }
                priceLeft ? (priceLeft.style.position = "fixed") : "";
                priceLeft ? (priceLeft.style.left = "40px") : "";
                priceLeft ? (priceLeft.style.top = "185px") : "";
                scrollTop ? (scrollTop.style.position = "fixed") : "";
                scrollTop ? (scrollTop.style.right = "15%") : "";
                scrollTop ? (scrollTop.style.top = "260px") : "";
                progress ? (progress.style.position = "fixed") : "";
                progress ? (progress.style.right = "7%") : "";
                progress ? (progress.style.top = "800px") : "";
                steamerRight ? (steamerRight.style.position = "fixed") : "";
                steamerRight ? (steamerRight.style.right = "280px") : "";
                steamerRight
                  ? (steamerRight.style.top = `${menu.offsetTop + menu.offsetHeight + 170
                    }px`)
                  : "";
                steamerRight
                  ? (steamerRight.style.maxHeight = `calc(100vh - ${menu.offsetTop + menu.offsetHeight + 170
                    }px - 50px)`)
                  : "";
              } else {
                this.collipsePanel = false; // 每次恢复悬浮时重置面板收缩状态
                this.contenta = false;
                menu ? (menu.style.position = "static") : "";
                scrollRight ? (scrollRight.style.position = "absolute") : "";
                scrollRight ? (scrollRight.style.right = "1%") : "";
                scrollRight ? (scrollRight.style.top = "0px") : "";
                scrollLeft ? (scrollLeft.style.position = "absolute") : "";
                scrollLeft ? (scrollLeft.style.left = "20px") : "";
                scrollLeft ? (scrollLeft.style.top = "10px") : "";
                assessLeft ? (assessLeft.style.position = "absolute") : "";
                assessLeft ? (assessLeft.style.left = "20px") : "";
                assessLeft ? (assessLeft.style.top = "410px") : "";
                assessRecord ? (assessRecord.style.position = "absolute") : "";
                assessRecord ? (assessRecord.style.left = "20px") : "";
                assessRecord
                  ? (assessRecord.style.top = `${10 + assessLeft.offsetHeight + 410
                    }px`)
                  : "";
                assessRecord ? (assessRecord.style.height = "135px") : "";
                priceLeft ? (priceLeft.style.position = "absolute") : "";
                priceLeft ? (priceLeft.style.left = "20px") : "";
                priceLeft ? (priceLeft.style.top = "30px") : "";
                scrollTop ? (scrollTop.style.position = "fixed") : "";
                scrollTop ? (scrollTop.style.right = "-9999px") : "";
                progress ? (progress.style.position = "fixed") : "";
                progress ? (progress.style.right = "-9999px") : "";
                steamerRight ? (steamerRight.style.position = "absolute") : "";
                steamerRight ? (steamerRight.style.right = "280px") : "";
                steamerRight ? (steamerRight.style.top = "220px") : "";
              }
            } else {
              //移动端
              if (pageH >= topHight) {
                scrollTop ? (scrollTop.style.position = "fixed") : "";
                scrollTop ? (scrollTop.style.right = "0px") : "";
                scrollTop ? (scrollTop.style.top = "300px") : "";
                progress ? (progress.style.position = "fixed") : "";
                progress ? (progress.style.right = "-9999px") : "";
              } else {
                scrollTop ? (scrollTop.style.position = "fixed") : "";
                scrollTop ? (scrollTop.style.right = "-9999px") : "";
                scrollTop ? (scrollTop.style.top = "200px") : "";
                progress ? (progress.style.position = "fixed") : "";
                progress ? (progress.style.right = "-9999px") : "";
              }
            }
          }
        } catch (e) { }
      });
    },
    // 添加用户采集记录
    async addUserCollections () {
      let param = {
        steam_id: this.form.steam_id,
        grade: this.goods.rank,
      };
      let res = await this.$userPost("/addUserCollections", param);
      // console.log(res);
      this.collections_id = res.collections_id || "";
      this.goods.prices = res.prices;
      this.goods.oldTitle.number = res.prices;
      this.goods.newTitle.number = res.prices;
    },
    // 获取总价
    async getPrices () {
      let param = {
        steam_id: this.form.steam_id,
      };
      let res = await this.$indexPost("/getPrices", param);
      this.goods.prices = res;
      this.goods.oldTitle.number = res;
      this.goods.newTitle.number = res;
    },
    // 是否显示价格
    showPrice () {
      if (!this.form.steam_id) {
        this.$message({
          message: "请先输入steam账号",
          type: "warning",
        });
        return false;
      }

      this.clonePopover();
      this.isPrice = !this.isPrice;
    },
    // 是否显示总价
    showTotalPrice () {
      if (!this.form.steam_id) {
        this.$message({
          message: "请先输入steam账号",
          type: "warning",
        });
        return false;
      }

      this.clonePopover();
      this.TotalPrice = !this.TotalPrice;
    },
    // 是否显示标签
    showGrade () {
      if (!this.form.steam_id) {
        this.$message({
          message: "请先输入steam账号",
          type: "warning",
        });
        return false;
      }
      // if(this.isGrade == true){
      //   this.isGrade = false
      // }else{}
      this.clonePopover();
      this.isGrade = !this.isGrade;
    },
    // 添加商品
    addGoods () {
      if (!this.form.steam_id) {
        this.$message({
          message: "请先输入steam账号",
          type: "warning",
        });
        return false;
      }

      let list = {
        name: "商品行",
        list: [],
        isCheck: false,
        select: JSON.parse(JSON.stringify(this.$options.data().select))
      };
      this.goods.suitData = [...this.goods.suitData, list];

      this.$message({ type: "success", message: "已添加商品行" });

      // this.goods.newLine = [[], ...this.goods.newLine]

      // this.goods.stagingGroup = [
      //   {
      //     name: 'site',
      //     pull: true, //可以拖出
      //     put: true, //可以拖入
      //   },
      //   ...this.goods.stagingGroup,
      // ]
      // this.clonePopover()
    },
    // 把一维数组变成二维
    arrChange (num, arr) {
      if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        num = 4;
      }
      const newArr = [];
      while (arr.length > 0) {
        newArr.push(arr.splice(0, num));
      }
      return newArr;
    },
    // 判断页面图片是否加载完
    isImage () {
      let that = this;
      let images = this.$refs.imga;
      let promiseAll = [],
        imgs = [],
        total = images.length;
      that.shopMsg.length = total;

      for (let i = 0; i < total; i++) {
        promiseAll[i] = new Promise((resolve, reject) => {
          images[i].onload = function () {
            resolve(imgs[i]);
          };
          images[i].onerror = function (e) {
            reject(e);
          };
        });
      }
      Promise.all(promiseAll)
        .then((img) => {
          // 全部图片加载完成
          that.isImageShow = true;
          glo_loading.loadingHide();
          that.progress.percentage = 100;
          that.$nextTick(function () {
            that.progress.percentage = 100;

            glo_loading.loadingHide();
          });
        })
        .catch((e) => {
          that.$nextTick(function () {
            glo_loading.loadingHide();
          });
          that.$message({
            message: "有库存信息加载失败，如有影响建议重新查询库存",
            type: "warning",
          });
          glo_loading.loadingHide();
        });
    },
    getRandomNum (Min, Max) {
      const Range = Max - Min + 1;
      const Rand = Math.random();
      return Min + Math.floor(Rand * Range);
    },
    clonePopover () {
      this.visible = false;
      this.bjvisible = false;
    },
    // 详情
    getDetail (status, item, index, type, item1, ind) {
      if (this.disabled) {
        this.setIntervalGetDetail(status, item, index, type, item1, ind);
      } else {
        this.timer = setInterval(() => {
          if (this.disabled) clearInterval(this.timer),
            this.setIntervalGetDetail(status, item, index, type, item1, ind);
        }, 100);
      }
    },
    // 详情
    setIntervalGetDetail (status, item, index, type, item1, ind) {
      if (item1?.id != this.isCheckId && !status) {
        let suitList = this.goods.suitData;
        let findIndex = suitList.findIndex(item => item.id == this.isCheckId);
        if (findIndex != -1) {
          this.$set(this.goods.suitData[findIndex], "isCheck", false);
        }
      }
      if (item1 && !status) {
        this.$set(this.goods.suitData[index].list[ind], "checked", !item.checked);
      }
      this.goods.armsGradeOptions = [];
      this.goods.arrIndex = type;
      if (type == "套装") {
        this.goods.suitDataIndex = index;
        this.goods.detailTopShow = false;
      } else {
        this.goods.detailTopShow = true;
      }
      if (item.libraryType) {
        // 素材区的数据，不需要走详情接口
        this.goods.detail = item;
        this.classid = item.classid;
        this.rankValue = item.rarity;
        if (
          this.goods.detail.grade && this.goods.detail.grade.indexOf("Lv") && item.is_up == 1) {
          this.goods.detail.grade = "Lv" + this.goods.detail.grade;
        }
        // 回显价格
        if (this.goods.detail.price == 0) {
          this.goods.detail.price = 0.0;
        }
        this.goodsId = item.id;
        if (this.facility !== "pc") {
          this.dialogVisible = true;
        }
      } else {
        this.goods.detail = {};
        this.classid = item.classid;

        let param = {
          classid: item.classid,
          steam_id: this.form.steam_id,
          id: item.id,
          number: item.number,
        };
        this.$indexPost("/getGoods_detail", param).then((res) => {
          // console.log(res);
          this.goodsIndex = index;
          this.goods.detail = item;
          this.rankValue = item.rarity;
          if (this.goods.detail.grade.indexOf("Lv") && item.is_up == 1) {
            this.goods.detail.grade = "Lv" + this.goods.detail.grade;
          }
          if (res.is_up == 1 && res.arms && res.arms.length > 0) {
            this.goods.armsGradeOptions = res.arms.map((arm) => {
              return { value: `Lv${arm.grade}`, label: `Lv${arm.grade}` };
            });
          }
          // 回显价格
          if (this.goods.detail.price == 0) {
            this.goods.detail.price = 0.0;
          }
          this.goodsId = item.id;
          if (this.facility !== "pc") {
            this.dialogVisible = true;
          }
        });
      }
    },
    rankValueChange (e) {
      let suitList = this.goods.suitData;
      let findIndex = suitList.findIndex(ele => ele.isCheck == true);
      if (findIndex != -1) {
        let checkSuitList = [];
        suitList[findIndex].list.forEach(ele => {
          if (ele.checked) checkSuitList.push(ele);
        })
        if (checkSuitList.length) {
          suitList[findIndex].list.forEach((ele, index) => {
            if (ele.checked) {
              this.$set(this.goods.suitData[findIndex].list[index], "rarity", e);
            };
          })
          // this.$confirm("您确认要修改多选商品的背景吗?", "提示", {
          //   confirmButtonText: "确定",
          //   cancelButtonText: "取消",
          //   type: "warning"
          // }).then(() => {
          //   suitList[findIndex].list.forEach((ele, index) => {
          //     if (ele.checked) {
          //       this.$set(this.goods.suitData[findIndex].list[index], "rarity", e);
          //     };
          //   })
          // });
        }
      } else {
        // rarity
        if (this.goods.arrIndex != "套装") {
          let arrs = this.goods.arrlist[this.goods.arrIndex].flat(Infinity);
          let index = arrs.findIndex((item) => item.id == this.goodsId);
          arrs[index].rarity = e;
          this.goods.arrlist[this.goods.arrIndex] = arrs;
        }

        if (this.goods.detail.libraryType && this.goods.suitData.length > 0) {
          // 对于由素材区拖入商品行里的数据，因为没有classid，需要额外处理
          if (this.goods.suitData.length > 0) {
            this.goods.suitData.forEach((item, i) => {
              item.list.forEach((item2, index) => {
                if (item2.libraryType && item2.id == this.goods.detail.id) {
                  this.goods.suitData[i].list[index].rarity = e;
                }
              });
            });
          }
        } else {
          // 商品行更新
          if (this.goods.suitData.length > 0) {
            this.goods.suitData.forEach((item, i) => {
              item.list.forEach((item2, index) => {
                if (item2.classid == this.goods.detail.classid) {
                  this.goods.suitData[i].list[index].rarity = e;
                }
              });
            });
          }
        }
      }
    },
    // 获取升级武器等级价格
    getArmsPrices (e) {
      this.disabled = false;
      let param = {
        steam_id: this.form.steam_id,
        classid: this.classid,
        grade: e.split("Lv")[1],
      };
      this.$indexPost("/getArmsPrice", param).then((res) => {
        this.upData();
        this.goods.detail.price = res;
        // this.getPrices();
      });
    },
    // 显示滤镜弹窗
    showFilter () {
      if (!this.form.steam_id) {
        this.$message({
          message: "请先输入setam账号",
          type: "warning",
        });
        return false;
      }
      this.visible = false;
      this.bjvisible = false;
      if (this.filtervisible) return (this.filtervisible = false);
      if (!this.filtervisible) return (this.filtervisible = true);
    },

    // 显示标题修改弹窗
    showTitlte () {
      if (!this.form.steam_id) {
        this.$message({
          message: "请先输入setam账号",
          type: "warning",
        });
        return false;
      }
      this.bjvisible = false;
      this.filtervisible = false;
      if (this.visible) return (this.visible = false);
      if (!this.visible) return (this.visible = true);
    },
    // 背景颜色
    showBjColor () {
      if (!this.form.steam_id) {
        this.$message({
          message: "请先输入setam账号",
          type: "warning",
        });
        return false;
      }
      this.visible = false;
      this.filtervisible = false;
      if (this.bjvisible) return (this.bjvisible = false);
      if (!this.bjvisible) return (this.bjvisible = true);
    },
    // 标题样式确认
    sumbitStyle () {
      this.goods.oldTitle.fontColor = this.goods.newTitle.fontColor;
      this.goods.oldTitle.fontSzie = this.goods.newTitle.fontSzie;
      this.goods.oldTitle.text = this.goods.newTitle.text;
      this.goods.oldTitle.fontFamily = this.goods.newTitle.fontFamily;
      this.goods.prices = this.goods.newTitle.number;
      this.visible = false;
    },
    // 标题重置
    resetStyle () {
      this.goods.newTitle.fontColor = DEFAULT_GOODS_TITLE_COLOR;
      this.goods.newTitle.fontSzie = 28;
      this.goods.newTitle.fontFamily = "microsoft yahei";
      this.goods.newTitle.text = this._collection_title;
      this.getPrices();
    },
    // 样式取消
    cancelStyle () {
      this.goods.newTitle.fontColor = this.goods.oldTitle.fontColor;
      this.goods.newTitle.fontSzie = this.goods.oldTitle.fontSzie;
      this.goods.newTitle.text = this.goods.oldTitle.text;
      this.goods.newTitle.fontFamily = this.goods.oldTitle.fontFamily;
      this.goods.newTitle.number = this.goods.prices;
      this.visible = false;
    },
    // 重置样式
    resetFilterStyle () {
      this.filterStyle = {
        grey: 0, // 灰度
        gass: 0, // 高斯模糊
        sepia: 0, // 深褐色
        saturation: 1, // 饱和度
        opacity: 1, // 透明度
        brightness: 1, // 亮暗度
        contrast: 1, // 对比度
        hueRotate: 0, // 色相转换
        invert: 0, // 反转
      };
    },
    // 获取更新商品
    getUpData () {
      this.goods.detail.classid = this.classid;
      if (this.classid != "library") {
        // 不是素材库的数据才更新
        this.goods.detail.steam_id = this.form.steam_id;
        this.$indexPost("/updateGoods", this.goods.detail).then((res) => {
          this.upData();
          this.getPrices();
        });
      }
    },
    upData () {
      let arrs, index;
      if (this.goods.arrIndex != "套装") {
        arrs = this.goods.arrlist[this.goods.arrIndex].flat(Infinity);
        index = arrs.findIndex((item) => item.id == this.goodsId);
        arrs[index] = this.goods.detail;
        this.goods.arrlist[this.goods.arrIndex] = arrs;
        this.disabled = true;
      }

      // switch (this.goods.arrIndex) {
      //   case 1:
      //     arrs = this.goods.arr1.flat(Infinity);
      //     index = arrs.findIndex((item) => item.id == this.goodsId);
      //     arrs[index] = this.goods.detail;
      //     this.goods.arr1 = arrs;
      //     break;
      //   case 2:
      //     arrs = this.goods.arr2.flat(Infinity);
      //     index = arrs.findIndex((item) => item.id == this.goodsId);
      //     arrs[index] = this.goods.detail;
      //     this.goods.arr2 = arrs;
      //     break;
      //   case 3:
      //     arrs = this.goods.arr3.flat(Infinity);
      //     index = arrs.findIndex((item) => item.id == this.goodsId);
      //     arrs[index] = this.goods.detail;
      //     this.goods.arr3 = arrs;
      //     break;
      //   case 4:
      //     arrs = this.goods.arr4.flat(Infinity);
      //     index = arrs.findIndex((item) => item.id == this.goodsId);
      //     arrs[index] = this.goods.detail;
      //     this.goods.arr4 = arrs;
      //     break;
      // }

      // 商品行更新
      if (this.goods.suitData.length > 0) {
        this.goods.suitData.forEach((e, i) => {
          e.list.forEach((item, index) => {
            if (item.classid == this.goods.detail.classid) {
              this.goods.suitData[i].list[index] = this.goods.detail;
            }
          });
        });
        this.disabled = true;
      }
    },

    // 置顶
    Topping () {
      let arrs, index;
      if (this.goods.arrIndex != "套装") {
        arrs = this.goods.arrlist[this.goods.arrIndex].flat(Infinity);
        index = arrs.findIndex((item) => item.id == this.goodsId);
        if (index == arrs.length - 1) {
          // 如果是最后一个，则关闭
          this.nextGoodsId = null;
          this.dialogVisible = false;
        } else {
          // 自动置换到下一个
          this.nextGoodsId = arrs[index + 1].id;
          this.getDetail(0, arrs[index + 1], index, this.goods.arrIndex);
        }
        if (this.goods.arrIndex == 0) {
          arrs.unshift(arrs.splice(index, 1)[0]);
          this.goods.arrlist[this.goods.arrIndex] = arrs;
        } else {
          this.goods.arrlist[0].unshift(arrs.splice(index, 1)[0]);
          this.goods.arrlist[this.goods.arrIndex] = arrs;
        }
        this.goodsId = this.nextGoodsId;
      }
    },
    // 删除
    remove () {
      let arrs, index, suitDataIndex;

      if (this.goods.arrIndex == "套装") {
        suitDataIndex = this.goods.suitDataIndex;
        arrs = this.goods.suitData[suitDataIndex].list.flat(Infinity);
        index = arrs.findIndex((item) => item.id == this.goodsId);
        if (index == arrs.length - 1) {
          // 如果是最后一个，则关闭
          this.nextGoodsId = null;
          this.dialogVisible = false;
        } else {
          // 自动置换到下一个
          this.nextGoodsId = arrs[index + 1].id;
          this.getDetail(0, arrs[index + 1], suitDataIndex, this.goods.arrIndex);
        }
        arrs.splice(index, 1);
        this.goods.suitData[suitDataIndex].list = arrs;
        this.goodsId = this.nextGoodsId;
      } else {
        arrs = this.goods.arrlist[this.goods.arrIndex].flat(Infinity);
        index = arrs.findIndex((item) => item.id == this.goodsId);
        if (index == arrs.length - 1) {
          // 如果是最后一个，则关闭
          this.nextGoodsId = null;
          this.dialogVisible = false;
        } else {
          // 自动置换到下一个
          this.nextGoodsId = arrs[index + 1].id;
          this.getDetail(0, arrs[index + 1], index, this.goods.arrIndex);
        }
        arrs.splice(index, 1);
        this.goods.arrlist[this.goods.arrIndex] = arrs;
        this.goodsId = this.nextGoodsId;
      }
    },
    // 暂存区清空
    transitionMove () {
      if (this.goods.arrlist.length == 0) {
        this.goods.arrlist = [[]];
      }
      this.goods.arrlist[0] = [...this.goods.staging, ...this.goods.arrlist[0]];
      this.goods.staging = [];
    },
    // 把图片切片
    generatorImage () {
      // 隐藏多选框
      let suitList = this.goods.suitData;
      suitList.forEach(ele => {
        ele.isCheck = false;
        ele.list.forEach(item => item.checked = false)
      })
      this.$set(this.goods, "suitList", suitList);
      // 若当前下载内容是套装分类，则在下载过程前先屏蔽左侧上移下移按钮，否则会导致高度变化和已获取的高度不一致，造成图片缺损
      // 为保持系统统一，只要是下载都屏蔽左侧按钮
      this.suitDownloading = true;
      this.goods.suitBtnShow = false;
      this.clonePopover();
      this.loopImg = 1;
      this.tempContentList = [];

      if (!this.form.steam_id || this.goods.arrlist.length <= 0) {
        this.$message({
          message: "请先输入setam账号采集数据后在下载",
          type: "warning",
        });
        // console.log('-------------------')
        return false;
      }
      if (!this.isImageShow) {
        this.$message({
          message: "还有商品未加载完成，请等待，或者请重新查询商品",
          type: "warning",
        });
        // console.log('-------------------')
        return false;
      }
      glo_loading.loadingShow("原图下载时间较长 请耐心等待");
      this.$nextTick(() => {
        // const height = this.$refs.canvasImg.offsetHeight;

        // // console.log(height,"总高");
        // // alert(height,"总高")
        // this.y = 0;
        // let domSplit = height;
        // if (height > 15000) {
        //   domSplit = 15000;
        //   if (height % domSplit) {
        //     this.lastLoopImg = Number((height % domSplit).toFixed(3));
        //     // console.log(this.lastLoopImg,"this.lastLoopImg");
        //     this.zLoopImg = Math.floor(height / domSplit) + 1;
        //     // console.log(this.lastLoopImg,"余数");
        //   } else {
        //     this.zLoopImg = Math.floor(height / domSplit);
        //     // console.log(this.lastLoopImg,"zLoopImg");
        //   }
        //   // console.log(this.zLoopImg,"总张");
        //   this.setCanvasImg(domSplit);
        // } else {
        //   domSplit = height;
        //   this.lastLoopImg = height;
        //   this.zLoopImg = 1;
        //   this.setCanvasImg(domSplit);
        // }

        const tempContents = document.querySelectorAll(".temp_content");
        tempContents.forEach((item) => {
          if (item.clientHeight !== 0) {
            this.tempContentList.push(item);
          }
        });
        this.zLoopImg = this.tempContentList.length;
        this.setCanvasImgNew();
      });
    },
    // 稀有度
    rarity (i) {
      // :0=普通,1=特殊,2=稀有,3=精英,4=史诗,5=传说
      if (i == "1" || i == 1) {
        return "rarity-A";
      }
      if (i == "2" || i == 2) {
        return "rarity-B";
      }
      if (i == "3" || i == 3) {
        return "rarity-C";
      }
      if (i == "4" || i == 4) {
        return "rarity-D";
      }
      if (i == "5" || i == 5) {
        return "rarity-E";
      }
    },
    handleClose () {
      this.dialogVisible = false;
    },
    // 绘制底图新版，由于html2canvas不兼容滤镜渐变色，所以采用modern-screenshot插件生成图片，后续和原功能一致
    async setCanvasImgNew () {
      const _this = this;
      for (let i = 0; i < this.tempContentList.length; i++) {
        _this.loopImg = i + 1;
        glo_loading.loadingSetText(`正在合成图片：${_this.loopImg}/${_this.zLoopImg}`);
        await _this.customImgPromise(this.tempContentList[i], i + 1);
      }
      // 都上传了 就开始下载
      glo_loading.loadingSetText(`正在拼接图片...`);
      _this.makeImage();
    },
    customImgPromise (node, index) {
      const _this = this;
      return new Promise((resolve, reject) => {
        domToCanvas(node, {
          filter (el) {
            if (el.id === "handle-btn") return false;
            if (el.id === "handle-btn1") return false;
            return true;
          },
          backgroundColor: _this.goods.goodsBjColor,
        }).then((canvas) => {
          let name = "steam/" + get(_this.form.steam_id) + "/" + index + ".png";
          let base = canvas.toDataURL("image/png", 0.95);
          let bableUrl = _this.blods(base, "image/png");

          let reader = new FileReader();
          reader.readAsArrayBuffer(bableUrl);
          reader.onload = function (event) {
            let buffer = new OSS.Buffer(event.target.result);
            let client = new OSS({
              region: _this.config.region,
              // accessKeyId: _this.config.accessKeyId,
              // accessKeySecret: _this.config.accessKeySecret,
              accessKeyId: get(_this.config.accessKeyId),
              accessKeySecret: get(_this.config.accessKeySecret),
              bucket: _this.config.bucket,
            });

            client
              .put(name, buffer)
              .then((res) => {
                // console.log(res.res.status == 200, "resOSS上传");
                // console.log(res.res.status, "resOSS上传");
                if (res.res.status == 200) {
                  let param = {
                    steam_id: _this.form.steam_id,
                    name: index,
                  };
                  _this
                    .$downloadsPost("/uploadsOSS", param)
                    .then((res1) => {
                      resolve();
                    })
                    .catch((err) => {
                      _this.suitDownloading = false; // 无脑重置套装分类下载状态
                      glo_loading.loadingHide();
                      _this.$message({
                        message: _this.facility == 'pc' ? "下载失败，图片生成中请不要切换网页，请检查网络，稍后再试" : "下载失败，手机用户生成中请不要切换后台屏幕不要熄灭，请检查网络，稍后再试",
                        type: "warning",
                      });

                      // _this.$message({
                      //   message:
                      //     "下载失败，手机用户生成中请不要切换后台屏幕不要熄灭，请检查网络，稍后再试",
                      //   type: "warning",
                      // });
                    });
                } else {
                  // console.log('resOSS上传失败');
                  _this.suitDownloading = false; // 无脑重置套装分类下载状态
                  glo_loading.loadingHide();
                  _this.$message({
                    message: _this.facility == 'pc' ? "下载失败，图片生成中请不要切换网页，请检查网络，稍后再试" : "下载失败，手机用户生成中请不要切换后台屏幕不要熄灭，请检查网络，稍后再试",
                    type: "warning",
                  });
                  // _this.$message({
                  //   message:
                  //     "下载失败，手机用户生成中请不要切换后台屏幕不要熄灭，请检查网络，稍后再试",
                  //   type: "warning",
                  // });
                  // 上传失败
                }
              })
              .catch((e) => {
                _this.suitDownloading = false; // 无脑重置套装分类下载状态
                glo_loading.loadingHide();
                _this.$message({
                  message: _this.facility == 'pc' ? "下载失败，图片生成中请不要切换网页，请检查网络，稍后再试" : "下载失败，手机用户生成中请不要切换后台屏幕不要熄灭，请检查网络，稍后再试",
                  type: "warning",
                });
                // _this.$message({
                //   message:
                //     "下载失败，手机用户生成中请不要切换后台屏幕不要熄灭，请检查网络，稍后再试",
                //   type: "warning",
                // });
                // console.log(e);
              });
          };
        });
      });
    },
    // 绘制底图
    setCanvasImg (height) {
      const _this = this;

      glo_loading.loadingSetText(
        `正在合成图片：${_this.loopImg - 1}/${_this.zLoopImg}`
      );
      html2canvas(this.$refs.canvasImg, {
        height: _this.loopImg === _this.zLoopImg ? _this.lastLoopImg : height,
        imageTimeout: 0,
        ignoreElements: (element) => {
          if (element.id === "handle-btn") return true;
          if (element.id === "handle-btn1") return true;
        },
        backgroundColor: "#000",
        y: this.y,
        x: 0,

        // foreignObjectRendering: true, // 是否在浏览器支持的情况下使用ForeignObject渲染
        async: false, // 是否异步解析和呈现元素
        useCORS: true,
        allowTaint: false,
        proxy: _this.config.imageUrl + "/uploads/pubg",
        scrollY: 0, // html2canvas默认绘制视图内的页面，需要把scrollY，scrollX设置为0
        scrollX: 0,
        scale: 0.95, // 处理模糊问题
      }).then((canvas) => {
        var context = canvas.getContext("2d");

        // Find the element with background-clip: text and get its position and size
        var element = document.querySelector(".goods_content .title");
        var rect = element.getBoundingClientRect();

        // Draw the text on the canvas
        context.font =
          window.getComputedStyle(element).getPropertyValue("font-size") +
          " " +
          window.getComputedStyle(element).getPropertyValue("font-family");
        context.fillStyle = window
          .getComputedStyle(element)
          .getPropertyValue("color");
        context.textAlign = window
          .getComputedStyle(element)
          .getPropertyValue("text-align");
        context.fillText(
          element.textContent,
          rect.left + rect.width / 2,
          rect.top + rect.height / 2
        );
        // console.log(context);

        // console.log(this.loopImg,this.zLoopImg);
        let base = "";
        let num = _this.loopImg;
        let name = "steam/" + get(_this.form.steam_id) + "/" + num + ".png";
        // console.log(name, '上传位置', this.loopImg, this.zLoopImg)
        if (this.zLoopImg == 1) {
          // console.log("z偶");
          base = canvas.toDataURL("image/png", 0.95);
          // console.log(base);
          // console.log(bableUrl,"bableUrl");
          name =
            "/uploads/user/" +
            this.userInfo.user_id +
            "/" +
            get(_this.form.steam_id) +
            ".png";
          this.ossUpload(base, name, num, height, 0);
        } else if (this.loopImg <= this.zLoopImg) {
          // console.log("z偶2");
          base = canvas.toDataURL("image/png", 0.95);
          // console.log("jinlail小于", this.loopImg,this.zLoopImg);
          this.y += height;
          this.loopImg++;
          this.ossUpload(base, name, num, height, 1);
        } else {
          // console.log("z偶3");
          // console.log("jinlail大于", this.loopImg,this.zLoopImg);
          // 都上传了 就开始下载
          glo_loading.loadingSetText(`正在拼接图片...`);

          this.makeImage();
        }
      });
    },

    /**
     * 上传oss
     * @param {base64} base64 - 图片的base64
     * @param {string} nameUrl - 上传位置.
     * @param {string} imgName - 图片名称.
     * @param {Number} height - 图片高度
     * @param {Number} type - 类型 0-单张 1-多张
     */
    ossUpload (base64, nameUrl, imgName, height, type) {
      let _this = this;
      let bableUrl = _this.blods(base64, "image/png");
      let reader = new FileReader();
      let canvasHeight = height;
      reader.readAsArrayBuffer(bableUrl);
      reader.onload = function (event) {
        let buffer = new OSS.Buffer(event.target.result);
        let client = new OSS({
          region: _this.config.region,
          // accessKeyId: _this.config.accessKeyId,
          // accessKeySecret: _this.config.accessKeySecret,
          accessKeyId: get(_this.config.accessKeyId),
          accessKeySecret: get(_this.config.accessKeySecret),
          bucket: _this.config.bucket,
        });

        client
          .put(nameUrl, buffer)
          .then((res) => {
            // console.log(res, 'resOSS上传');
            if (res.res.status == 200) {
              if (type == 0) {
                _this.downloadFile(base64);
              } else {
                _this.uploadsOSS(imgName, canvasHeight, type);
              }
            } else {
              // console.log('resOSS上传失败');
              _this.suitDownloading = false; // 无脑重置套装分类下载状态
              glo_loading.loadingHide();
              _this.$message({
                message: _this.facility == 'pc' ? "下载失败，图片生成中请不要切换网页，请检查网络，稍后再试" : "下载失败，手机用户生成中请不要切换后台屏幕不要熄灭，请检查网络，稍后再试",
                type: "warning",
              });
              // _this.$message({
              //   message:
              //     "下载失败，手机用户生成中请不要切换后台屏幕不要熄灭，请检查网络，稍后再试",
              //   type: "warning",
              // });
              // 上传失败
            }
          })
          .catch((e) => {
            _this.suitDownloading = false; // 无脑重置套装分类下载状态
            glo_loading.loadingHide();
            _this.$message({
              message: _this.facility == 'pc' ? "下载失败，图片生成中请不要切换网页，请检查网络，稍后再试" : "下载失败，手机用户生成中请不要切换后台屏幕不要熄灭，请检查网络，稍后再试",
              type: "warning",
            });
            // _this.$message({
            //   message:
            //     "下载失败，手机用户生成中请不要切换后台屏幕不要熄灭，请检查网络，稍后再试",
            //   type: "warning",
            // });
            // console.log(e);
          });
      };
    },
    // 通知获取绘制图片
    async uploadsOSS (name, height) {
      // console.log(name, height, 'name,height')
      let _this = this;
      // console.log(_this.loopImg,_this.zLoopImg,_this.lastLoopImg,"_this.loopImg,_this.zLoopImg,_this.lastLoopImg");
      let canvasHeight = height;
      let param = {
        steam_id: this.form.steam_id,
        name: name,
      };
      this.$downloadsPost("/uploadsOSS", param)
        .then((res) => {
          _this.setCanvasImg(canvasHeight);
        })
        .catch((err) => {
          this.suitDownloading = false; // 无脑重置套装分类下载状态
          glo_loading.loadingHide();
          _this.$message({
            message: _this.facility == 'pc' ? "下载失败，图片生成中请不要切换网页，请检查网络，稍后再试" : "下载失败，手机用户生成中请不要切换后台屏幕不要熄灭，请检查网络，稍后再试",
            type: "warning",
          });
          // this.$message({
          //   message:
          //     "下载失败，手机用户生成中请不要切换后台屏幕不要熄灭，请检查网络，稍后再试",
          //   type: "warning",
          // });
        });
    },
    // 下载图片
    async makeImage () {
      let _this = this;
      let param = {
        steam_id: this.form.steam_id,
        user_id: this.userInfo.user_id,
      };
      this.$downloadsPost("/makeImage", param)
        .then((res) => {
          _this.suitDownloading = false; // 无脑重置套装分类下载状态
          glo_loading.loadingHide();
          let time = new Date().getTime();
          res = _this.config.imageUrl + `${res}?time=` + time;
          // console.log('213123'+res);
          _this.downloadFile2(res);
          _this.goods.suitBtnShow = true;
          _this.success(res);
        })
        .catch((err) => {
          glo_loading.loadingHide();
          _this.suitDownloading = false; // 无脑重置套装分类下载状态
          _this.$message({
            message: _this.facility == 'pc' ? "下载失败，图片生成中请不要切换网页，请检查网络，稍后再试" : "下载失败，手机用户生成中请不要切换后台屏幕不要熄灭，请检查网络，稍后再试",
            type: "warning",
          });
          // _this.$message({
          //   message: "下载失败，手机用户生成中请不要切换后台屏幕不要熄灭，请检查网络，稍后再试",
          //   type: "warning",
          // });
        });
    },
    success (url) {
      this.$message({
        message: `如未弹出下载可以复制下面链接手动下载 \n\n\n <a style="cursor: pointer;color:red" id='goToFile'>点我跳转下载页面</a>`,
        // JSX support
        duration: 10000,
        dangerouslyUseHTMLString: true,
      });
      // 监听message实例的点击实例
      document
        .getElementById("goToFile")
        .addEventListener("click", function () {
          window.open(url);
        });
    },
    goToFile (url) {
      window.open(url);
    },

    // 本地base转blob
    base64ToBlob (code) {
      let parts = code.split(";base64,");
      let contentType = parts[0].split(":")[1];
      let raw = window.atob(parts[1]);
      let rawLength = raw.length;

      let uInt8Array = new Uint8Array(rawLength);

      for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
      }
      return new Blob([uInt8Array], { type: contentType });
    },
    // 本地图片下载方法
    downloadFile (content) {
      this.goods.suitBtnShow = true;
      let aLink = document.createElement("a");
      let blob = this.base64ToBlob(content); //new Blob([content]);

      let evt = document.createEvent("HTMLEvents");
      evt.initEvent("click", true, true); //initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
      aLink.download = get(this.form.steam_id);
      aLink.href = URL.createObjectURL(blob);

      // aLink.dispatchEvent(evt);
      aLink.click();
      this.addUserDownloads();
      this.suitDownloading = false; // 无脑重置套装分类下载状态
      glo_loading.loadingHide();
    },
    // 上传Oss base转blob
    blods (urlData, type) {
      var arr = urlData.split(",");
      var mime = arr[0].match(/:(.*?);/)?.[1] || type;
      var bytes = window.atob(arr[1]);
      var ab = new ArrayBuffer(bytes.length);
      var ia = new Uint8Array(ab);
      for (let i = 0; i < bytes.length; i++) {
        ia[i] = bytes.charCodeAt(i);
      }
      return new Blob([ab], {
        type: mime,
      });
    },
    // Oss图片下载方法
    downloadFile2 (data) {
      let that = this;

      var x = new XMLHttpRequest();
      x.open("GET", data, true);
      x.responseType = "blob";
      x.onload = function (e) {
        var url = window.URL.createObjectURL(x.response);
        var a = document.createElement("a");
        a.href = url;
        a.download = get(that.form.steam_id);
        a.click();
        that.addUserDownloads();
      };
      x.send();
    },
    async addUserDownloads () {
      let time = new Date().getTime();
      let param = {
        steam_id: this.form.steam_id,
        token: this.token,
        pic_image: `/uploads/user/${this.userInfo.user_id}/${get(
          this.form.steam_id
        )}.png`,
      };
      await this.$userPost("/addUserDownloads", param);
    },
    // 估价
    assessSuccess (data) {
      this.$refs.assessDialog
        ? this.$refs.assessDialog.showDialog(
          data.price,
          data.levelImg,
          data.levelColor
        )
        : null;
      this.$refs.assessRecord ? this.$refs.assessRecord.reload() : null;
    },
    // 估价面板收起展开，刷新估价记录位置
    changeShowPanel () {
      setTimeout(() => {
        this.handleScroll();
      }, 400);
    },
    clickCollipse () {
      this.collipsePanel = !this.collipsePanel;
      this.settingCollipse = this.collipsePanel;
      this.$nextTick(() => {
        this.handleScroll();
      });
    },
    // 初始化素材区内容
    initLibraryList () {
      this.$indexPost("/getLibrary").then((res) => {
        this.originLibraryList = res.map((item) => {
          return {
            ...item,
            myClassId: item.classid,
            classid: "library",
            grade: "",
            describe: "",
            is_up: item.is_up != undefined ? Number(item.is_up) : "",
            number: 1,
            price_x: 0,
            libraryType: 1, // 标识是素材区内容，详情不会调接口
          };
        });
        this.goods.library = [...this.originLibraryList];
      });
    },
    // 获取主播区数据
    initAnchorList () {
      getAnchorList().then(res => {
        this.originSteamerList = res.data
      })
    },
    // 点击主播区显示弹框
    steamerClick (item) {
      this.steamerDetail = item
      this.showSteamerDetail = true
    },
    // 复制微信
    wechatCopy () {
      const _this = this
      const clipboard = new Clipboard('.wechatClipboardBtn', { text: () => _this.steamerDetail.wechat })
      clipboard.on('success', e => {
        _this.$message.success('复制成功')
        clipboard.destroy()
      })
      clipboard.on('error', e => {
        this.$message.warning('复制失败')
        clipboard.destroy()
      })
    },
    // 复制QQ
    qqCopy () {
      const _this = this
      const clipboard = new Clipboard('.qqClipboardBtn', { text: () => _this.steamerDetail.qq })
      clipboard.on('success', e => {
        _this.$message.success('复制成功')
        clipboard.destroy()
      })
      clipboard.on('error', e => {
        this.$message.warning('复制失败')
        clipboard.destroy()
      })
    }
  },
  destroyed () {
    window.removeEventListener("scroll", this.handleScroll, true);
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/home/index.scss";
@import "@/assets/css/home/pc.scss";
@import "@/assets/css/home/phone.scss";
</style>
